import React, { useState, useEffect } from "react";
import "./index.css";
import xpentraloader from "../../../assets/Beneficiary Icons/lodemore.gif";
import info from "../../../assets/InfoIcons/Info.svg";
import transactionHistory from "../../../assets/GeneralIcons/transaction_history.svg";
import arrowRight from "../../../assets/ArrowsIcons/ChevronRightWhite.svg";
import arrow_right_black from "../../../assets/ArrowsIcons/arrow_right_white – 2.svg";
import arrow_down from "../../../assets/ArrowsIcons/arrow_down_white.svg";
import arrow_up from "../../../assets/ArrowsIcons/arrow_up_white.svg";
import arrow_right_white_filled from "../../../assets/ArrowsIcons/arrow_right_white_filled.svg";
import timeline_dot from "../../../assets/RadioIcons/timeline_dot.svg";
import declineImage from "../../../assets/RejectIcons/reject_icon_red_with_white_circle.svg";
import approveImage from "../../../assets/CheckmarksIcons/approve_circle_green_checkmark.svg";
import skipping_verification from "../../../assets/ErrorIcons/error_with_white_outlined_circle.svg";
import whiteLoader from "../../../assets/LoaderIcons/xpentra lodemore 1.svg";
import default_file from "../../../assets/FileFormatIcons/DefaultImage.svg";
import closeIcon from "../../../assets/General Icons/close.svg";
import error_with_white_outlined_circle from "../../../assets/ErrorIcons/error_with_white_outlined_circle.svg";
import { Tooltip, tooltipClasses } from "@mui/material";
import { toast, Bounce } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  internalTxnAccountDetail,
  internalTxnRequireApprovalPage,
  internalTxnApproval,
} from "../../../redux/features/internalTransaction/internalTransactionDetailPage";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import formatCurrency from "../../../utils/CurrencyFormater";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import { checkUsertoken } from "../../../redux/features/login/login";
import IfscCodeMapper from "../../../components/_utils/IfscLogoMapper";
import ISO_DataFormatter from "../../../utils/ISO_DataFormatter";
import { displayPlatform } from "../../../components/_utils/DisplayEnvironment/displayenv";
import { displayBrowser } from "../../../components/_utils/DisplayEnvironment/displayenv";
import { displayOS } from "../../../components/_utils/DisplayEnvironment/displayenv";
import TransactionHistory from "../../../components/TransactionHistoryModal";
import InternalAccDetailsPopUp from "../../../components/Accounts/InternalAccDetailPopup";
import DeclinedPopup from "../../Accounts/BeneficiaryAccount/BeneAcountApproval/DeclinedPopup";
import arrowLeftimg from "../../../assets/ArrowsIcons/arrow_left_white.svg";
import arrowDownBlueWhite from "../../../assets/ArrowsIcons/arrow_down_blue_white.svg";
import confidential_transactionImg from "../../../assets/GeneralIcons/confidential_transaction.svg";
import Loader from "../../../components/Loader/Index";
import redirect from "../../../assets/GeneralIcons/redirect.svg";
import FullScreen from "../../../components/FullScreen";

const InternalTransactionDetails = ({
  internal_txn_id,
  closeInternalTxnDetailModal,
  type,
  error_msg,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const [showDetails, setShowDetails] = useState(true);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [infoBox, setInfoBox] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [viewInternalTxnDetails, setViewInternalTxnDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState(0);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [loadingBox, setLoadingBox] = useState(false);
  const [internalTxnDetailID, setInternalTxnDetailID] = useState("");
  const [internalAccountID, setInternalAccountID] = useState("");
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(error_msg ? error_msg : "");
  const [entityId, setEntityId] = useState("");
  const [checkInternalTransaction, setCheckInternalTransaction] =
    useState(false);
  const [internalAccountDetailpop, setInternalAccountDetailpop] =
    useState(false);
  const services = useSelector((state) => state.refreshToken.services);
  const {
    internalTxnDataLoading,
    internalTxnData,
    internalTxnApprovalLoading,
  } = useSelector((state) => state.internalTxnViewData);
  const [modalType, setModalType] = useState("");
  const hasConfidential = services?.includes("VConfidentialTxn");
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  useEffect(() => {
    async function fetchData() {
      if (internalTxnDataLoading) setLoading(true);
      try {
        dispatch(checkUsertoken());
        let response;
        if (type === "internal_txn_detail_modal") {
          response = await dispatch(internalTxnAccountDetail(internal_txn_id));
        } else {
          response = await dispatch(internalTxnAccountDetail(id));
        }
        if (
          !response?.payload ||
          response?.error?.status === 404 ||
          response?.error?.status === 401
        ) {
          navigate("/*");
          return;
        }
      } catch (error) {
        (() => {})();
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    if (internalTxnData) {
      const newData = internalTxnData?.transaction?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
      }));
      setViewInternalTxnDetails(newData);
      setEntityId(internalTxnData?.transaction?.[0]?.entity_id);
      setInternalTxnDetailID(internalTxnData?.transaction?.[0]?.txn_id);
      setInternalAccountID(
        internalTxnData?.transaction?.[0]?.internal_account_id
      );
    }
  }, [internalTxnData]);

  useEffect(() => {
    const fetchTotalPages = async () => {
      try {
        let response = null;
        if (entityId) {
          dispatch(checkUsertoken());
          response = await dispatch(
            internalTxnRequireApprovalPage({
              entityId: entityId,
              page_no: 1,
            })
          );
        }
        const total_pages = response?.payload?.title?.total_pages || 1;
        setPages(total_pages);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchTotalPages();
  }, [dispatch, entityId]);

  useEffect(() => {
    const fetchAllData = async () => {
      if (!pages) return;
      let allTransactions = [];

      setLoadingBox(true);
      for (let page = 1; page <= pages; page++) {
        try {
          let response = null;
          if (
            entityId &&
            internalTxnData?.transaction?.[0]?.lifecycle_status === "pending"
          ) {
            dispatch(checkUsertoken());
            response = await dispatch(
              internalTxnRequireApprovalPage({
                entityId: entityId,
                page_no: page,
              })
            );
          }

          const transactionsData = response?.payload?.transactions || [];
          allTransactions = [...allTransactions, ...transactionsData];
        } catch (error) {
          (() => {})();
          break;
        }
      }
      const transactionExists = allTransactions.some(
        (obj) => obj.txn_id === internalTxnDetailID
      );
      if (transactionExists) {
        setCheckInternalTransaction(transactionExists);
      }
      setLoadingBox(false);
    };
    fetchAllData();
  }, [dispatch, entityId, internalTxnDetailID, pages]);

  const bene_account_id =
    internalTxnData?.transaction?.[0]?.internal_account_id;

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleDeclinedDetails = (id) => {
    setInternalTxnDetailID(id);
    setShowDeclineModal(true);
  };

  const closeDeclineModal = () => {
    setShowDeclineModal(false);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccountDetailpop(false);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewInternalTxnDetails(updatedAccounts);
  };

  const showToast = () => {
    toast.info("Coming soon", toast_position);
  };

  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(viewInternalTxnDetails?.[0]?.logs?.length || 0).fill(false)
  );

  const [openDistributionTimeline, setOpenDistributionTimeline] = useState(
    Array(viewInternalTxnDetails?.[0]?.distribution_logs?.length || 0).fill(
      false
    )
  );

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(viewInternalTxnDetails?.[0]?.distribution_logs?.length).fill(false)
    );
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
  };

  const handleDistributionClick = () => {
    setShowDistributionTimeline(!showDistributionTimeline);
    if (!showDistributionTimeline) {
      setShowDetails(true);
      setShowAdditionalDetails(false);
      setShowApprovalTimeline(false);
    }
    setOpenApprovalTimeline(false);
  };

  const renderApprovalData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem = index === array.length - 1;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-5" : ""
              }`}
            >
              <div className="w-2 border-b-2 border-solid border-Primary_grey"></div>

              <p
                key={key}
                className="w-full text-Primary_grey text-sm text-left font-sans font-normal ml-2 make-first-letter-small break-words"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  const renderDistributionData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem = index === array.length - 1;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-5" : ""
              }`}
            >
              <div className="w-2 border-b-2 border-solid border-Primary_grey"></div>
              <p
                key={key}
                className="w-full text-Primary_grey text-sm text-left font-sans font-normal ml-2 make-first-letter-small truncate"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  const additional_data = internalTxnData?.transaction?.[0]?.additional_data;

  const validItems = additional_data?.data ? additional_data?.data : [];

  const attachments = validItems.filter(
    (obj) => (obj.name === "Hyperlink" || obj.name === "File") && "value" in obj
  );

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const closeModal = () => {
    if (infoBox) {
      setInfoBox(false);
    }
  };

  const toggleDetails = () => {
    setShowDetails(true);
    setShowAdditionalDetails(false);
  };

  const toggleAdditionalDetails = () => {
    setShowAdditionalDetails(true);
    setShowDetails(false);
  };

  const handleApproveInternalTransaction = async (id) => {
    dispatch(checkUsertoken());
    const paragraphStyle = {
      width: "160px",
      height: "19px",
      textAlign: "left",
      font: "normal normal normal 14px/19px Open Sans",
      letterSpacing: "0px",
      color: "FFFFFF",
      Opacity: 1,
    };
    const divStyle = {
      display: "flex",
      gap: "10px",
      justifyContent: "center",
      alignItems: "center",
    };
    const imageStyle = {
      width: "40px",
      height: "40px",
      Opacity: 1,
    };
    toast(
      <div style={divStyle} className="approving-toast-beneTxn">
        <img src={whiteLoader} alt="" style={imageStyle} />
        <p style={paragraphStyle}> Approving transaction </p>
      </div>,
      {
        position: "bottom-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        fontSize: "20px",
        transition: Bounce,
        style: {
          width: window.innerWidth > 600 ? "252px" : window.innerWidth + "px",
          height: "84px",
          borderRadius: "10px",
          backgroundColor: "var(--Toast_processing)",
          color: "var(--Primary_white)",
        },
      }
    );
    setTimeout(() => {
      toast.dismiss();
    }, 1000);
    let res;
    if (type === "internal_txn_detail_modal") {
      res = await dispatch(internalTxnApproval(internal_txn_id));
    } else {
      res = await dispatch(internalTxnApproval(id));
    }
    if (res?.payload === undefined) {
      setNetworkError(
        "An error occured while taking action on this transaction"
      );
      setTimeout(() => {
        toast.error(
          "An error occured while taking action on this transaction",
          toast_position
        );
      }, 2000);
    } else if (res?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, 2000);
    } else if (
      res?.payload?.status === false ||
      res.type === "beneTxnWaitingApproval/rejected"
    ) {
      if (
        res?.payload?.errors?.base?.[0]?.errors &&
        res?.payload?.errors?.base?.[0]?.errors?.[0]?.reason
      ) {
        const error_msg = res?.payload?.errors?.base?.[0]?.errors?.[0]?.reason;
        if (!Array.isArray(error_msg)) {
          setErrorMessage(error_msg);
          setTimeout(() => {
            toast.error(error_msg, toast_position);
          }, 1000);
        } else {
          setErrorMessage(res.payload.errors.base?.[0].errors?.[0].reason?.[0]);
          if (res.payload.errors.base?.[0].errors?.[0].reason.length >= 1) {
            let msgs = res.payload.errors.base?.[0].errors?.[0].reason;
            msgs.forEach((error) => {
              if (res?.payload?.status === false) {
                setTimeout(() => {
                  toast.error(error, toast_position);
                }, 1000);
              }
            });
          }
        }
      } else if (
        res?.payload?.errors?.base?.[0]?.reason &&
        res?.payload?.errors?.base?.[0]?.reason?.[0]
      ) {
        setErrorMessage(res?.payload?.errors?.base?.[0]?.reason?.[0]);
        setTimeout(() => {
          toast.error(
            res?.payload?.errors?.base?.[0]?.reason?.[0],
            toast_position
          );
        }, 1000);
      } else if (res?.payload?.errors?.base?.[0]) {
        setErrorMessage(res.payload.errors.base?.[0]);
        setTimeout(() => {
          toast.error(res.payload.errors.base?.[0], toast_position);
        }, 2000);
      }
    } else {
      const updatedData = internalTxnData?.transaction?.map((data) => {
        return {
          ...data,
          lifecycle_status: res?.payload?.transactions?.[0]?.lifecycle_status,
          last_updated_status:
            res?.payload?.transactions?.[0]?.last_updated_status,
          last_updated_user_id:
            res?.payload?.transactions?.[0]?.last_updated_user_id,
        };
      });
      setViewInternalTxnDetails(updatedData);
      dispatch(checkUsertoken());
      if (type === "internal_txn_detail_modal") {
        await dispatch(internalTxnAccountDetail(internal_txn_id));
      } else {
        await dispatch(internalTxnAccountDetail(id));
      }
      if (res?.payload?.status === true) {
        if (type === "internal_txn_detail_modal") {
          let getSessionData = JSON.parse(
            sessionStorage.getItem("selectedData")
          );
          sessionStorage.setItem(
            "selectedData",
            JSON.stringify({
              selectedSendTransactions:
                getSessionData?.selectedSendTransactions?.filter(
                  (fil) => fil.txn_id !== internal_txn_id
                ),
              selectedTransactions:
                getSessionData?.selectedTransactions?.filter(
                  (fil) => fil !== internal_txn_id
                ),
            })
          );
        }
        setTimeout(() => {
          toast.success(" Transaction approved successfully", toast_position);
        }, 1000);
      }
      if (type === "internal_txn_detail_modal") {
        setTimeout(() => {
          closeInternalTxnDetailModal();
          window.location.reload();
        }, 5000);
      }
    }
  };

  const actionRestricted = () => {
    // toast(
    //   <div className="flex flex-row p-2.5">
    //     <img src={error_with_white_outlined_circle} className="w-6 h-6" />
    //     <p className="text-sm ml-2 mt-0.5">Action restricted in popup mode.</p>
    //   </div>,
    //   {
    //     position: "bottom-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //     style: {
    //       // width: window.innerWidth > 600 ? "252px" : window.innerWidth + "px",
    //       // height: "84px",
    //       // borderRadius: "10px",
    //       backgroundColor: "var(--Toast_error)",
    //       color: "var(--Primary_white)",
    //     },
    //   }
    // );
    toast.warn("Action restricted in popup mode.", toast_position);
  };

  return (
    <>
      {alertPopUp && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center bg-Primary_black justify-center z-[9998] bg-opacity-80">
          <FullScreen
            type={"internalTxn"}
            id={internal_txn_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      <div
        style={{
          height: type === "internal_txn_detail_modal" ? "100%" : "100vh",
          overflowX: "hidden",
          overflowY: openTransHistory ? "hidden" : "auto",
          scrollbarWidth: "none",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div className="bene-detail-loader-box m-auto justify-center items-center flex">
            <img src={xpentraloader} alt="" />
          </div>
        ) : (
          <div
            className="internalTxnDetailsPage"
            style={{
              marginTop: type === "internal_txn_detail_modal" ? "" : "76px",
            }}
          >
            {type === "internal_txn_detail_modal" && (
              <div
                className={`${
                  type === "internal_txn_detail_modal"
                    ? "flex flex-row justify-between items-center p-5 absolute z-10 w-full bg-Blue_3"
                    : "none"
                }`}
              >
                <div className="flex flex-col space-y-1">
                  <p className="text-base text-Primary_white font-sans font-semibold">
                    Internal Transaction Details
                  </p>
                </div>
                <div className="flex">
                  <div
                    onClick={() => setAlertPopUp(true)}
                    className="bg-Blue_5 w-[150px] h-[30px] rounded-md cursor-pointer flex mr-2.5 items-center hover:bg-Blue_5_hover"
                  >
                    <p className="text-Primary_white text-Font_14 ml-2.5 font-normal">
                      Open in full view{" "}
                    </p>
                    <img
                      className="w-[13px] h-[13px] ml-2"
                      src={redirect}
                      alt="redirect"
                    />
                  </div>
                  <div
                    className="flex justify-center items-center cursor-pointer w-7 h-7 rounded-[5px] bg-Blue_5 hover:bg-Blue_7"
                    onClick={() => closeInternalTxnDetailModal()}
                  >
                    <img src={closeIcon} className="w-4 h-4" />
                  </div>
                </div>
              </div>
            )}
            {openTransHistory && (
              <div className="fixed top-0 left-0 w-screen h-screen z-[9998] bg-black bg-opacity-80">
                <TransactionHistory
                  owner_account_id={
                    internalTxnData?.transaction?.[0]?.owner_account_id
                  }
                  owner_account_bank_acc_no={
                    internalTxnData?.transaction?.[0]?.owner_account_bank_acc_no
                  }
                  internal_account_confidential={
                    modalType === "Confidential Transaction"
                      ? internalTxnData?.transaction?.[0]
                          ?.confidential_transaction
                      : null
                  }
                  txnHistorytype={"internalTxnHistory"}
                  onClose={closeTransactionHistory}
                  popup={modalType}
                />
              </div>
            )}

            {internalAccountDetailpop && (
              <div
                className="fixed top-0 left-0 w-screen h-screen z-[9998] bg-Primary_black bg-opacity-80"
                onClick={() => {
                  closeBeneAccountDetailModal();
                }}
              >
                <InternalAccDetailsPopUp
                  closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                  bene_account_id={internalAccountID}
                  type={"bene_account_detail_modal"}
                />
              </div>
            )}

            {showDeclineModal && (
              <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[9998] bg-black bg-opacity-80">
                <DeclinedPopup
                  modal_type="internal_txn_detail_modal"
                  onClose={closeDeclineModal}
                  accountId={internalTxnDetailID}
                  status="internal-transaction"
                  allAccounts={viewInternalTxnDetails}
                  updateAllAccounts={updateAllAccounts}
                  closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                  closeInternalTxnDetailModal={closeInternalTxnDetailModal}
                />
              </div>
            )}

            <div
              className={`internaltxn-account-primary-details ${
                type === "internal_txn_detail_modal" ? "pt-[68px]" : ""
              }`}
            >
              {internalTxnData?.transaction?.map((account) => (
                <div
                  key={account.txn_id}
                  className={`w-full h-auto ${
                    type === "internal_txn_detail_modal" ? "" : "mt-7"
                  }`}
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    maxWidth: "1024px",
                  }}
                >
                  <div className="flex flex-row border-b-2 border-solid border-Blue_3">
                    <div className="flex flex-row my-6 w-1/2 justify-between">
                      <div className="flex flex-col space-y-1">
                        <div className="flex flex-row gap-x-1">
                          <p className="text-Settled font-sans font-semibold text-base text-left">
                            &#8377; {formatCurrency(account.total_amount)}
                          </p>
                          <div className="relative">
                            <img
                              src={info}
                              className="w-3 h-3 cursor-pointer relative"
                              onClick={showAmountInfo}
                            />
                            {infoBox && (
                              <div
                                className="w-80 h-auto absolute flex flex-col top-4 z-10 rounded-[20px]"
                                style={{}}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="h-14 bg-Blue_7 p-5 rounded-t-[20px]">
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey text-right font-sans font-normal leading-[16.34px]">
                                      Transaction amount
                                    </span>
                                    <span className="text-sm text-Settled text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.total_amount)}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex-1 bg-Blue_5 p-5 rounded-b-[20px]">
                                  <div className="flex flex-row justify-between">
                                    <span className=" text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Amount debited
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.total_amount)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center ">
                                    <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                  </div>
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Tax amount
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.tax_amount)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center ">
                                    <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                  </div>
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Payment charge
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.payment_charge)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center">
                                    <span className="w-4 h-2 text-Primary_white text-2xl">
                                      =
                                    </span>
                                  </div>
                                  <div className="mt-8 border border-solid border-Blue_1"></div>
                                  <div className="flex flex-row justify-between mt-4">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Amount credited
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(
                                        account.total_amount -
                                          account.tax_amount -
                                          account.payment_charge
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                          Transaction amount
                        </p>
                      </div>
                      <div className="mr-10 space-y-1">
                        <p className="text-Primary_white	text-base text-right font-sans font-normal">
                          {account.distribution_utr
                            ? account.distribution_utr
                            : "N/A"}
                        </p>
                        <p className="text-Primary_grey text-xs text-right font-sans font-normal">
                          UTR number
                        </p>
                      </div>
                    </div>
                    <div className="border border-solid border-Blue_3 my-3.5"></div>
                    <div className="flex flex-row justify-between w-1/2">
                      <div className="ml-10 space-y-1 my-6">
                        <p className="text-Primary_white text-base text-left font-sans font-normal">
                          {formatDateViewAll(account?.created_on, true, true)}
                        </p>
                        <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                          Initiated on
                        </p>
                      </div>
                      <div className="flex flex-row bg-Blue_7">
                        {hasConfidential &&
                        internalTxnData?.transaction?.[0]
                          ?.confidential_transaction === "Y" ? (
                          <div
                            className={`w-24 h-full flex flex-col justify-center place-items-center space-y-1 ${
                              type === "internal_txn_detail_modal"
                                ? "cursor-default opacity-50"
                                : "cursor-pointer hover:bg-gray-200 hover:bg-opacity-20"
                            }`}
                            onClick={() => {
                              if (type === "internal_txn_detail_modal") {
                                actionRestricted();
                              } else {
                                openTransactionHistory();
                                setModalType("Confidential transaction");
                              }
                            }}
                          >
                            <img
                              src={confidential_transactionImg}
                              className="w-8 h-8"
                            />
                            <p className="text-Primary_white text-[10px] text-center font-sans font-normal">
                              Confidential transactions
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        {hasConfidential &&
                          internalTxnData?.transaction?.[0]
                            ?.confidential_transaction === "Y" && (
                            <div className="border border-solid border-Blue_3 my-3.5"></div>
                          )}

                        <div
                          className={`w-24 h-full flex flex-col justify-center place-items-center space-y-1 ${
                            type === "internal_txn_detail_modal"
                              ? "cursor-default opacity-50"
                              : "cursor-pointer hover:bg-gray-200 hover:bg-opacity-20"
                          }`}
                          onClick={() => {
                            if (type === "internal_txn_detail_modal") {
                              actionRestricted();
                            } else {
                              openTransactionHistory();
                              setModalType("Transaction history");
                            }
                          }}
                        >
                          <img src={transactionHistory} className="w-8 h-8" />
                          <p className="text-Primary_white text-[10px] text-center font-sans font-normal pr-1 pl-1">
                            Transaction history
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-row">
                    <div className="flex flex-row py-3.5 w-1/2 justify-between">
                      <div
                        className="p-2 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 rounded-lg -ml-2.5"
                        onClick={() =>
                          navigate(
                            `/accounts/owner/owner_account_details/${account.owner_account_id}`
                          )
                        }
                      >
                        <div className="flex flex-col space-y-1">
                          <div className="flex flex-row items-center">
                            <p className="text-Primary_white text-base text-left font-sans font-normal">
                              {formatAccountNumber(
                                account.owner_account_bank_acc_no
                              )}
                            </p>
                            <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md ml-5">
                              <img
                                src={arrowRight}
                                alt="document"
                                className="w-2.5 h-2.5 "
                              />
                            </div>
                          </div>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                            Source account
                          </p>
                        </div>
                      </div>
                      <div className="bg-Primary_white rounded-[20px] flex items-center justify-around h-7 w-20 mt-2 mr-10">
                        <img
                          src={require("../../../assets/IfscLogo/" +
                            IfscCodeMapper(account.owner_account_ifsc_code))}
                          alt="Source account bank name"
                          className="w-14 h-4"
                        />
                      </div>
                    </div>
                    <div className="border border-solid border-Blue_3 mt-3.5 h-9"></div>
                    <div className="flex flex-row py-3.5 w-1/2 justify-between">
                      <div
                        className="p-2 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 rounded-lg ml-8"
                        onClick={() =>
                          navigate(
                            `/accounts/internal_account/details/${account?.internal_account_id}`
                          )
                        }
                      >
                        <div className="flex flex-col space-y-1">
                          <div className="flex flex-row items-center">
                            <p className="text-Primary_white text-base text-left font-sans font-normal">
                              {formatAccountNumber(
                                account?.internal_account_bank_acc_no
                              )}
                            </p>
                            <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md ml-5">
                              <img
                                src={arrowRight}
                                alt="document"
                                className="w-2.5 h-2.5 "
                              />
                            </div>
                          </div>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                            Destination account
                          </p>
                        </div>
                      </div>
                      <div className="bg-Primary_white rounded-[20px] flex items-center justify-around h-7 w-20 mt-2">
                        <img
                          src={require("../../../assets/IfscLogo/" +
                            IfscCodeMapper(
                              account?.internal_account_ifsc_code
                            ))}
                          alt="Destination account bank name"
                          className="w-14 h-4"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-center items-center">
                    <img
                      src={arrow_right_black}
                      className="w-5 h-5 -mt-9"
                      alt="Internal_Transaction_Arrow"
                    />
                  </div>

                  <div className="flex flex-row -mt-6">
                    <div className="flex flex-row py-5 w-1/2 justify-between">
                      <div className="flex flex-col space-y-1">
                        <p className="text-Primary_white text-base text-left font-sans font-normal">
                          {account.owner_account_ifsc_code}
                        </p>
                        <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                          IFSC code
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 mr-10">
                        <p className="w-80 text-Primary_white text-base	text-right	font-sans font-normal capitalize truncate block overflow-ellipsis">
                          {account?.payment_method}
                        </p>
                        <p className="text-Primary_grey text-xs	font-sans font-normal text-right">
                          Payment method
                        </p>
                      </div>
                    </div>
                    <div className="border border-solid border-Blue_3 mt-7 mb-5"></div>
                    <div className="flex flex-row w-1/2 py-5 justify-between">
                      <div className="flex flex-col space-y-1 ml-10 w-1/2">
                        <p className="text-Primary_white text-base font-sans font-normal	text-left">
                          {account?.internal_account_ifsc_code}
                        </p>
                        <p className="text-Primary_grey text-xs	font-sans font-normal text-left">
                          IFSC code
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 w-1/2">
                        <p className="text-Primary_white text-base text-right	font-sans font-normal capitalize whitespace-normal break-words block overflow-ellipsis">
                          {account?.internal_account_name?.toLowerCase()}
                        </p>
                        <p className="text-Primary_grey text-xs	font-sans font-normal text-right">
                          Account name
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className={`Txntimeline ${
                type === "internal_txn_detail_modal" ? "w-full" : "w-screen"
              } bg-Blue_3`}
            >
              <div className="flex flex-row w-full max-w-5xl m-auto">
                <div
                  className={`flex flex-col w-1/2 h-auto mt-5 rounded-t-[15px] rounded-bl-[15px] overflow-hidden relative ${
                    internalTxnData?.transaction?.[0]
                      ?.distribution_lifecycle_status ===
                      "distribution_complete" ||
                    internalTxnData?.transaction?.[0]?.lifecycle_status ===
                      "abandoned" ||
                    (internalTxnData?.transaction?.[0]?.lifecycle_status ===
                      "approved" &&
                      internalTxnData?.transaction?.[0]
                        ?.internal_account_approval_status !== "pending")
                      ? "bg-Blue_3"
                      : "bg-Blue_2"
                  }`}
                >
                  <div className="pt-px bg-Blue_5">
                    <p className="text-Primary_grey text-xs text-left font-sans font-normal my-2 ml-5">
                      Transaction Timeline
                    </p>
                  </div>
                  <div className="border border-solid border-Blue_2"></div>
                  <div className="flex flex-row flex-grow">
                    <div
                      className="Approval-box w-1/2 cursor-pointer bg-Blue_5 hover:bg-Blue_7"
                      onClick={() => {
                        setShowApprovalTimeline(!showApprovalTimeline);
                        if (!showApprovalTimeline) {
                          setShowDetails(true);
                          setShowAdditionalDetails(false);
                          setShowDistributionTimeline(false);
                        }
                        setOpenDistributionTimeline(false);
                      }}
                    >
                      <div className="flex flex-row justify-between mt-2 mx-5">
                        <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                          Stage 1 - Approval
                        </p>
                        <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                          <img
                            src={showApprovalTimeline ? arrow_up : arrow_down}
                            alt="document"
                            className="w-2.5 h-2.5 "
                          />
                        </div>
                      </div>
                      {viewInternalTxnDetails?.length >= 1 &&
                        viewInternalTxnDetails?.map((account) =>
                          account?.lifecycle_status === "rejected" ? (
                            <>
                              <p className="text-Failed text-sm text-left capitalize font-sans font-semibold mt-2.5 mb-1 ml-5">
                                {account.lifecycle_status}
                              </p>
                            </>
                          ) : account?.lifecycle_status === "approved" ? (
                            <>
                              <p className="text-Awaiting text-sm text-left capitalize font-sans font-semibold mt-2.5 mb-1 ml-5">
                                {account.lifecycle_status}
                              </p>
                            </>
                          ) : account?.lifecycle_status === "abandoned" ? (
                            <>
                              <p className="text-Abandoned text-sm text-left capitalize font-sans font-semibold mt-2.5 mb-1 ml-5">
                                {account.lifecycle_status}
                              </p>
                            </>
                          ) : account.last_updated_status === "Approved" &&
                            account.last_updated_user_id ===
                              loginid?.employees?.id ? (
                            <>
                              <p className="text-Pending text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5">
                                Pending
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="text-Pending text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5">
                                {services?.find(
                                  (service) => service === "AInternalTxn"
                                ) === undefined
                                  ? "Pending"
                                  : "Require approval"}
                              </p>
                            </>
                          )
                        )}

                      <p className="text-Primary_grey text-[10px] text-left font-sans font-normal ml-5">
                        Status
                      </p>
                    </div>
                    <div className="bg-Blue_5">
                      <div className="border border-solid border-Blue_2 h-16 mt-2"></div>
                    </div>
                    <div
                      className={`Distribution-box w-1/2 rounded-br-[15px] ${
                        viewInternalTxnDetails?.length >= 1 &&
                        viewInternalTxnDetails?.[0]
                          ?.distribution_lifecycle_status
                          ? "bg-Blue_5 hover:bg-Blue_7 cursor-pointer"
                          : "bg-Blue_5 cursor-default"
                      }`}
                      onClick={
                        viewInternalTxnDetails?.length >= 1 &&
                        viewInternalTxnDetails?.[0]
                          ?.distribution_lifecycle_status
                          ? handleDistributionClick
                          : null
                      }
                    >
                      <div className="flex flex-row justify-between mt-2 mx-5">
                        <p
                          className={`text-Primary_grey text-xs text-left font-sans font-normal ${
                            viewInternalTxnDetails?.length >= 1 &&
                            viewInternalTxnDetails?.[0]
                              ?.distribution_lifecycle_status
                              ? "opacity-100"
                              : "opacity-50"
                          }`}
                        >
                          Stage 2 - Distribution
                        </p>
                        <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                          <img
                            src={
                              showDistributionTimeline ? arrow_up : arrow_down
                            }
                            alt="document"
                            className={`w-2.5 h-2.5 ${
                              viewInternalTxnDetails?.length >= 1 &&
                              viewInternalTxnDetails?.[0]
                                ?.distribution_lifecycle_status
                                ? "opacity-100"
                                : "opacity-50"
                            }`}
                          />
                        </div>
                      </div>
                      {viewInternalTxnDetails?.map((account) =>
                        account?.distribution_lifecycle_status ===
                        "distribution_complete" ? (
                          <>
                            <p className="text-Settled text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5 opacity-100">
                              Distribution complete
                            </p>
                          </>
                        ) : account?.distribution_lifecycle_status ===
                            "rejected" ||
                          account?.distribution_lifecycle_status ===
                            "failed" ? (
                          <>
                            <p className="text-Failed text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5 opacity-100">
                              {`Distribution ${account?.distribution_lifecycle_status}`}
                            </p>
                          </>
                        ) : account?.distribution_lifecycle_status ===
                          "abandoned" ? (
                          <>
                            <p className="text-Abandoned text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5 opacity-100">
                              {"Distribution".concat(
                                " ",
                                account.distribution_lifecycle_status
                              )}
                            </p>
                          </>
                        ) : account?.distribution_lifecycle_status ? (
                          <>
                            <p className="text-Queued text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5 opacity-100">
                              {account.distribution_lifecycle_status ===
                              "created"
                                ? "Distribution created"
                                : account.distribution_lifecycle_status ===
                                  "approved"
                                ? "Distribution approved"
                                : account.distribution_lifecycle_status ===
                                  "awaiting_funds"
                                ? "Awaiting funds"
                                : account.distribution_lifecycle_status ===
                                  "distribution_initiated"
                                ? "Distribution initiated"
                                : account.distribution_lifecycle_status}
                            </p>
                          </>
                        ) : (
                          <>
                            <p
                              className={`${
                                account?.distribution_lifecycle_status
                                  ? "opacity-100 text-Queued"
                                  : "opacity-50 text-Primary_white"
                              } text-sm text-left font-sans font-semibold mt-2.5 mb-1 ml-5`}
                            >
                              {account?.distribution_lifecycle_status
                                ? account?.distribution_lifecycle_status
                                : "N/A"}
                            </p>
                          </>
                        )
                      )}

                      <p
                        className={`text-Primary_grey text-[10px] text-left font-sans font-normal ml-5 ${
                          internalTxnData?.transaction?.[0]
                            ?.distribution_lifecycle_status
                            ? "opacity-100"
                            : "opacity-50"
                        }`}
                      >
                        Status
                      </p>
                    </div>
                  </div>
                  {viewInternalTxnDetails?.length >= 1 &&
                    viewInternalTxnDetails?.map((account) =>
                      account?.lifecycle_status === "rejected" ? (
                        <>
                          <div className="px-5 h-3 absolute w-full top-28 mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-rejected-approval absolute top-0.5 left-0 py-[2.5px] px-[3px]"
                                value={0.5}
                              />
                            </div>
                          </div>
                        </>
                      ) : account?.distribution_lifecycle_status ===
                          "rejected" ||
                        account?.distribution_lifecycle_status === "failed" ? (
                        <>
                          <div className="px-5 h-3 absolute w-full top-28 mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-rejected-approval absolute top-0.5 left-0 px-0.5 pt-px"
                                value={1}
                              />
                            </div>
                          </div>
                        </>
                      ) : account?.lifecycle_status === "abandoned" ||
                        account?.distribution_lifecycle_status ===
                          "abandoned" ? (
                        <>
                          <div className="px-5 h-3 absolute w-full top-28 mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-abandoned-transaction absolute top-0.5 left-0 px-0.5 pt-px"
                                value={`${
                                  account?.lifecycle_status === "abandoned"
                                    ? 0.5
                                    : account?.distribution_lifecycle_status ===
                                      "abandoned"
                                    ? 1
                                    : 0.5
                                }`}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="px-5 h-3 absolute w-full top-28 mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-require-approval absolute top-0.5 left-0 px-0.5 pt-px"
                                value={`${
                                  account?.distribution_lifecycle_status ===
                                  "distribution_complete"
                                    ? 1
                                    : account?.distribution_lifecycle_status
                                    ? 0.75
                                    : 0.25
                                }`}
                              />
                            </div>
                          </div>
                        </>
                      )
                    )}
                </div>
                {viewInternalTxnDetails?.map((account) =>
                  loadingBox && account.lifecycle_status === "pending" ? (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-3/5 h-[106px] mt-[52px] bg-[#102C5D]"></div>
                        <div className="flex justify-center items-center w-2/5 h-[106px] mt-[52px] bg-[#102C5D] rounded-tr-[15px] rounded-br-[15px]">
                          <Loader />
                        </div>
                      </div>
                    </>
                  ) : networkError || errorMessage || account.message ? (
                    <>
                      <div className="flex flex-row w-1/2">
                        <div className="flex-grow w-1/12 h-[106px] mt-[52px] bg-Blue_2"></div>
                        <div className="flex-grow w-11/12 h-[106px] mt-[52px] bg-Failed_to_take_action rounded-tr-[15px] rounded-br-[15px] p-4 space-y-0.5">
                          <div className="flex flex-row h-full">
                            <div className="flex-none w-[10%] mt-2">
                              <img
                                src={skipping_verification}
                                className="h-7 w-7"
                              />
                            </div>
                            <div className="flex-1 flex-col space-y-1 ml-2.5">
                              <p className="text-Primary_white text-sm text-left font-sans font-normal">
                                Failed to take action
                              </p>

                              <Tooltip
                                componentsProps={{
                                  popper: {
                                    sx: {
                                      zIndex: 9999,
                                      [`& .${tooltipClasses.tooltip}`]: {
                                        backgroundColor: (theme) =>
                                          theme.palette.common.black,
                                      },
                                      [`& .${tooltipClasses.arrow}`]: {
                                        color: (theme) =>
                                          theme.palette.common.black,
                                      },
                                    },
                                  },
                                }}
                                title={
                                  networkError
                                    ? "An error occurred while taking action on this transaction"
                                    : errorMessage
                                    ? errorMessage
                                    : account.message
                                    ? account.message
                                    : ""
                                }
                                arrow
                                placement="bottom"
                                PopperProps={{
                                  style: {
                                    maxWidth: "none",
                                  },
                                }}
                              >
                                <p className="text-Primary_grey text-xs text-left font-sans font-normal line-clamp">
                                  {networkError
                                    ? "An error occurred while taking action on this transaction"
                                    : errorMessage
                                    ? errorMessage
                                    : account.message
                                    ? account.message
                                    : ""}
                                </p>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : account.last_updated_status === "Approved" &&
                    account.lifecycle_status === "pending" &&
                    account.last_updated_user_id === loginid?.employees?.id ? (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-1/12 h-[106px] mt-[52px] bg-Blue_2"></div>
                        <div className="flex-grow w-11/12 h-[106px] mt-[52px] bg-Blue_5 rounded-tr-[15px] rounded-br-[15px] p-5 space-y-1">
                          <p className="text-Pending text-sm text-left font-sans font-normal">
                            Further approval pending
                          </p>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                            This transaction has been approved by you, but it
                            requires another user's approval before settlement.
                          </p>
                        </div>
                      </div>
                    </>
                  ) : account.last_updated_status === "Approved" &&
                    account.lifecycle_status === "pending" &&
                    services?.find((service) => service === "AInternalTxn") ===
                      undefined ? (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-1/12 h-[106px] mt-[52px] bg-Blue_2"></div>
                        <div className="flex-grow w-11/12 h-[106px] mt-[52px] bg-Blue_5 rounded-tr-[15px] rounded-br-[15px] p-5 space-y-1">
                          <p className="text-Pending text-sm text-left font-sans font-normal">
                            Further approval pending
                          </p>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                            This transaction requires another user's approval
                            before settlement.
                          </p>
                        </div>
                      </div>
                    </>
                  ) : account?.lifecycle_status === "rejected" ? (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-1/12 h-[106px] mt-[52px] bg-Blue_2"></div>
                        <div className="flex-grow w-11/12 h-[106px] mt-[52px] bg-Blue_5 rounded-tr-[15px] rounded-br-[15px] p-5 space-y-0.5">
                          <p className="text-Failed text-sm text-left font-sans font-normal">
                            Rejected reason
                          </p>

                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  zIndex: 9999,
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  [`& .${tooltipClasses.arrow}`]: {
                                    color: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account.rejection_reason}
                            arrow
                            placement="bottom"
                            PopperProps={{
                              style: {
                                maxWidth: "none",
                              },
                            }}
                          >
                            <p className="text-Primary_grey text-xs text-justify font-sans font-normal line-clamp">
                              {account.rejection_reason}
                            </p>
                          </Tooltip>
                        </div>
                      </div>
                    </>
                  ) : account?.internal_account_approval_status ===
                    "pending" ? (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-1/12 h-[106px] mt-[52px] bg-Blue_2"></div>
                        <div className="flex-grow w-11/12 h-[106px] mt-[52px] bg-Blue_5 rounded-tr-[15px] rounded-br-[15px] px-5 py-4">
                          <p className="text-Pending text-sm text-left font-sans font-normal">
                            Account approval pending
                          </p>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal mt-1">
                            {services?.find(
                              (service) => service === "AInternalTxn"
                            ) !== undefined
                              ? "Account is not approved, approve account before approving transaction."
                              : "To approve the account, please contact the authorized person."}
                          </p>
                          <div
                            className={`flex justify-between items-center w-[150px] h-7 py-1 px-2.5 mt-2 rounded-[5px] bg-Blue_3 ${
                              services?.find(
                                (service) => service === "AInternalTxn"
                              ) !== undefined
                                ? "opacity-100 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20"
                                : "opacity-50 cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (
                                services?.find(
                                  (service) => service === "IAAccount"
                                ) !== undefined
                              ) {
                                setInternalAccountDetailpop(true);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "IAAccount",
                                  },
                                });
                              }
                            }}
                          >
                            <p className="text-xs text-Primary_white font-sans font-regular">
                              Approve Account
                            </p>
                            <img
                              src={arrow_right_white_filled}
                              className="w-3 h-3"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : account?.internal_account_approval_status ===
                      "approved" && account.lifecycle_status === "pending" ? (
                    <>
                      <div className="w-1/2 flex flex-row mt-[52px] bg-Blue_2 rounded-tr-[15px] rounded-br-[15px]">
                        <div className="flex-grow w-3/5 h-[106px]"></div>
                        <div
                          className={`flex flex-row w-2/5 h-[106px] rounded-[15px] overflow-hidden ${
                            checkInternalTransaction
                              ? "opacity-100"
                              : "opacity-50"
                          }`}
                        >
                          <div
                            className={`w-1/2 h-full bg-Button_red  flex flex-col justify-center place-items-center space-y-1 ${
                              checkInternalTransaction
                                ? "hover:opacity-80 cursor-pointer"
                                : "cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (
                                services?.find(
                                  (service) => service === "AInternalTxn"
                                ) !== undefined &&
                                checkInternalTransaction
                              ) {
                                handleDeclinedDetails(account.txn_id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "AInternalTxn",
                                  },
                                });
                              }
                            }}
                          >
                            <img src={declineImage} className="w-7 h-7" />
                            <p className="text-Primary_white text-xs text-center font-sans font-normal">
                              Reject
                            </p>
                          </div>
                          <div
                            className={`w-1/2 h-full bg-Button_green flex flex-col justify-center place-items-center space-y-1 ${
                              checkInternalTransaction
                                ? "hover:opacity-80 cursor-pointer"
                                : " cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (
                                services?.find(
                                  (service) => service === "AInternalTxn"
                                ) !== undefined &&
                                checkInternalTransaction
                              ) {
                                handleApproveInternalTransaction(
                                  account.txn_id
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "AInternalTxn",
                                  },
                                });
                              }
                            }}
                          >
                            <img src={approveImage} className="w-7 h-7" />
                            <p className="text-Primary_white text-xs text-center font-sans font-normal">
                              Approve
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="w-1/2 flex flex-row">
                        <div className="flex-grow w-5/12 h-[106px] mt-[52px] bg-Blue_3"></div>
                        <div className="flex-grow w-7/12 h-[106px] mt-[52px] bg-Blue_3"></div>
                      </div>
                    </>
                  )
                )}
              </div>
            </div>

            {showApprovalTimeline ? (
              <>
                <div className="bg-Blue_3 py-10">
                  {viewInternalTxnDetails?.length >= 1 &&
                    [...viewInternalTxnDetails?.[0]?.logs]
                      ?.reverse()
                      .map((account, index) => {
                        const trackCount =
                          (index + 1) %
                            viewInternalTxnDetails?.[0]?.logs?.length ===
                          0;
                        const logs_length =
                          viewInternalTxnDetails?.[0]?.logs?.length;
                        const num = index + 1;
                        return (
                          <>
                            <div
                              key={index}
                              className="flex fex-row items-start w-full max-w-5xl m-auto space-x-10 relative"
                            >
                              <div
                                className={`absolute border-l-2 border-solid border-Blue_7 w-[4%] ${
                                  num === logs_length
                                    ? "h-10 duration-500 ease-in-out"
                                    : openApprovalTimeline[index]
                                    ? "h-full duration-500 ease-in-out"
                                    : "h-20 duration-500 ease-in-out"
                                }`}
                              >
                                <div className="absolute flex flex-row w-full">
                                  <img
                                    src={timeline_dot}
                                    className="w-5 h-5 mt-[31px] ml-[-11px]"
                                  />
                                  <div className="w-6 border-t-2 mt-10 ml-1 border-solid border-Blue_7"></div>
                                </div>

                                {showApprovalTimeline && num === 1 && (
                                  <>
                                    <div className="absolute border-l-2 border-solid border-Blue_7 h-6 ml-[-1.75px] -mt-6"></div>
                                    <div className="absolute border-t-2 border-solid border-Blue_7 w-36 ml-0 -mt-6"></div>
                                    <div className="absolute border-r-2 border-solid border-Blue_7 h-[18px] ml-36 -mt-10"></div>
                                  </>
                                )}
                              </div>

                              <div
                                className={`flex flex-col w-full px-5 py-5 rounded-[15px] bg-Blue_5 hover:bg-gray-200 hover:bg-opacity-20 cursor-pointer overflow-hidden approval-data ${
                                  openApprovalTimeline[index]
                                    ? "h-auto"
                                    : "h-20"
                                }`}
                                onClick={() => handleApprovalTimeline(index)}
                              >
                                <div className="flex flex-row items-center">
                                  <div className="flex flex-row items-center w-3/12 border-r-2 border-solid border-Blue_3">
                                    <div className="flex flex-col space-y-1 ml-2">
                                      <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                        {account.action === "Add Status"
                                          ? account.remark.toLowerCase()
                                          : account.action.toLowerCase()}
                                      </p>
                                      <p className="text-Primary_grey text-[10px] text-left font-sans font-normal">
                                        Action
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex flex-row items-center w-9/12">
                                    {account?.browser_name && (
                                      <div className="flex flex-row items-center w-1/3 border-r-2 border-solid border-Blue_3">
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayBrowser(
                                              account?.browser_name
                                            ) +
                                            ".svg")}
                                          alt="Browser"
                                          className="w-7 h-7 ml-4"
                                        />
                                        <div className="flex flex-col space-y-1 ml-3">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.browser_name ===
                                            "Microsoft Edge (Chromium)"
                                              ? "Microsoft Edge"
                                              : account.browser_name}
                                          </p>
                                          <p className="text-Primary_grey text-[10px] text-left font-sans font-normal">
                                            Browser
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {account?.platform && (
                                      <div className="flex flex-row items-center w-1/3 border-r-2 border-solid border-Blue_3">
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayPlatform(account?.platform) +
                                            ".svg")}
                                          alt="Platform"
                                          className="w-7 h-7 ml-4"
                                        />
                                        <div className="flex flex-col space-y-1 ml-3">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.platform}
                                          </p>
                                          <p className="text-Primary_grey text-[10px] text-left font-sans font-normal">
                                            Platform
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {account?.os_version && (
                                      <div className="flex flex-row items-center w-1/3">
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayOS(account?.os_version) +
                                            ".svg")}
                                          alt="OS version"
                                          className="w-7 h-7 ml-4"
                                        />
                                        <div className="flex flex-col space-y-1 ml-3">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.os_version}
                                          </p>
                                          <p className="text-Primary_grey text-[10px] text-left font-sans font-normal">
                                            Operating system
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                                    <img
                                      src={
                                        openApprovalTimeline[index]
                                          ? arrow_up
                                          : arrow_down
                                      }
                                      alt="document"
                                      className="w-2.5 h-2.5 "
                                    />
                                  </div>
                                </div>
                                {openApprovalTimeline[index] && (
                                  <>
                                    <div className="ml-8 mt-5">
                                      {renderApprovalData(account)}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            {num !== logs_length && (
                              <>
                                <div className="max-w-5xl m-auto h-5 border-l-2 border-solid border-Blue_7"></div>
                              </>
                            )}
                          </>
                        );
                      })}
                </div>
              </>
            ) : showDistributionTimeline ? (
              <>
                <div className="bg-Blue_3 py-10">
                  {viewInternalTxnDetails?.length >= 1 &&
                    [...viewInternalTxnDetails?.[0]?.distribution_logs]
                      ?.reverse()
                      .map((account, index) => {
                        const trackCount =
                          (index + 1) %
                            viewInternalTxnDetails?.[0]?.distribution_logs
                              ?.length ===
                          0;
                        const distributionLogs_length =
                          viewInternalTxnDetails?.[0]?.distribution_logs
                            ?.length;
                        const num = index + 1;
                        return (
                          <>
                            <div
                              key={index}
                              className="flex fex-row items-start w-full max-w-5xl m-auto space-x-10 relative"
                            >
                              <div
                                className={`absolute border-l-2 border-solid border-Blue_7 w-[4%] ${
                                  num === distributionLogs_length
                                    ? "h-10 duration-500 ease-in-out"
                                    : openDistributionTimeline[index]
                                    ? "h-full duration-500 ease-in-out"
                                    : "h-20 duration-500 ease-in-out"
                                }`}
                              >
                                <div className="absolute flex flex-row w-full">
                                  <img
                                    src={timeline_dot}
                                    className="w-5 h-5 mt-[31px] ml-[-11px]"
                                  />
                                  <div className="w-6 border-t-2 mt-10 ml-1 border-solid border-Blue_7"></div>
                                </div>

                                {showDistributionTimeline && num === 1 && (
                                  <>
                                    <div className="absolute border-l-2 border-solid border-Blue_7 h-6 ml-[-1.75px] -mt-6"></div>
                                    <div className="absolute border-t-2 border-solid border-Blue_7 w-96 ml-0 -mt-6"></div>
                                    <div className="absolute border-r-2 border-solid border-Blue_7 h-[18px] ml-96 -mt-10"></div>
                                  </>
                                )}
                              </div>
                              <div
                                className={`flex flex-col w-full px-5 py-5 rounded-[15px] bg-Blue_5 hover:bg-gray-200 hover:bg-opacity-20 cursor-pointer overflow-hidden distribution-data ${
                                  openDistributionTimeline[index]
                                    ? "h-auto"
                                    : "h-20"
                                }`}
                                onClick={() =>
                                  handleDistributionTimeline(index)
                                }
                              >
                                <div className="flex flex-row justify-between items-center">
                                  <div className="flex flex-row items-center">
                                    <div className="flex flex-col space-y-1 ml-2">
                                      <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                        {account.action === "Add Status"
                                          ? account.remark.toLowerCase()
                                          : account.action.toLowerCase()}
                                      </p>
                                      <p className="text-Primary_grey text-[10px] text-left font-sans font-normal">
                                        Action
                                      </p>
                                    </div>
                                  </div>
                                  <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                                    <img
                                      src={
                                        openDistributionTimeline[index]
                                          ? arrow_up
                                          : arrow_down
                                      }
                                      alt="document"
                                      className="w-2.5 h-2.5 "
                                    />
                                  </div>
                                </div>
                                {openDistributionTimeline[index] && (
                                  <>
                                    <div className="ml-2 mt-5">
                                      {renderDistributionData(account)}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            {num !== distributionLogs_length && (
                              <>
                                <div className="max-w-5xl m-auto h-5 border-l-2 border-solid border-Blue_7"></div>
                              </>
                            )}
                          </>
                        );
                      })}
                </div>
              </>
            ) : (
              <div
                className={`details-div-trans mb-5 bg-Blue_3 ${
                  type === "internal_txn_detail_modal" ? "w-full" : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto bg-Blue_3 m-auto max-w-5xl">
                  <div className="buttonsfordetails">
                    <button
                      className={`DetailsButton w-20 h-7 mr-5 ${
                        showDetails ? "effective" : "hover:bg-Detail_chip_hover"
                      }`}
                      onClick={toggleDetails}
                    >
                      <span
                        className={`text-xs text-center font-sans font-semibold ${
                          showDetails ? "text-black" : "text-white"
                        } `}
                      >
                        Details
                      </span>
                    </button>
                    <button
                      className={`AdditionalDetailsButton w-36 h-7 ${
                        showAdditionalDetails
                          ? "effective"
                          : "hover:bg-Detail_chip_hover"
                      }`}
                      onClick={toggleAdditionalDetails}
                    >
                      <span
                        className={`text-xs text-center font-sans font-semibold ${
                          showAdditionalDetails ? "text-black" : "text-white"
                        }`}
                      >
                        Additional details
                      </span>
                    </button>
                  </div>
                  {showDetails &&
                    viewInternalTxnDetails?.map((account) => (
                      <div
                        className={`flex my-8 ${
                          account?.distribution_lifecycle_status ===
                          "distribution_complete"
                            ? "justify-between"
                            : "space-x-5"
                        }`}
                      >
                        <div
                          className="
                           w-[328px]
                        h-auto px-7 py-5 rounded-[20px] bg-Blue_5 self-start"
                        >
                          <p className="text-Primary_grey text-Font_14 text-left font-sans font-semibold pb-5">
                            Origin Details
                          </p>
                          <p className="text-Primary_white text-Font_14 text-left font-sans font-normal mb-1 whitespace-normal break-words">
                            {account?.logs?.[0]?.first_name +
                              " " +
                              account?.logs?.[0]?.last_name[0].toUpperCase() +
                              account?.logs?.[0]?.last_name.slice(1)}
                          </p>

                          <p className="text-Primary_grey text-Font_12 text-left font-sans font-normal">
                            Initiated by
                          </p>
                        </div>

                        {account?.distribution_lifecycle_status ===
                        "distribution_complete" ? (
                          <>
                            <div
                              className="
                           w-[328px]
                        h-auto px-7 py-5 rounded-[20px] bg-Blue_5"
                            >
                              <p className="text-Primary_grey text-Font_14 text-left font-sans font-semibold pb-5">
                                Settlement Details
                              </p>
                              <p className="text-Primary_white text-Font_14 text-left font-sans font-normal mb-1">
                                {account?.distribution_credited_at
                                  ? ISO_DataFormatter(
                                      account?.distribution_credited_at
                                    )
                                  : "N/A"}
                              </p>
                              <p className="text-Primary_grey text-Font_12 text-left font-sans font-normal border-b border-solid border-Blue_2 pb-2.5">
                                Settled on
                              </p>
                              <p className="text-Primary_white text-Font_14 text-left font-sans font-normal pt-2.5 mb-1 block w-full whitespace-normal break-words">
                                {account?.distribution_settlement_id
                                  ? account?.distribution_settlement_id
                                  : "N/A"}
                              </p>
                              <p className="text-Primary_grey text-Font_12 text-left font-sans font-normal">
                                Settlement ID
                              </p>
                            </div>
                            <div className="w-[328px] h-auto px-7 py-5 rounded-[20px] bg-Blue_5 self-start">
                              <p className="text-Font_14 text-Primary_grey text-left font-sans font-semibold pb-5">
                                Support Information
                              </p>

                              <p
                                id="id-firstLetter"
                                className="text-Primary_white text-Font_14 font-sans font-normal text-left w-full mb-1 whitespace-normal break-words"
                              >
                                {account.txn_id}
                              </p>

                              <p className="text-Primary_grey text-Font_12 font-sans font-normal text-left">
                                Transaction ID
                              </p>
                            </div>
                          </>
                        ) : (
                          <div className="w-[328px] h-auto px-7 py-5 rounded-[20px] bg-Blue_5 self-start">
                            <p className="text-Font_14 text-Primary_grey text-left font-sans font-semibold pb-5">
                              Support Information
                            </p>

                            <p
                              id="id-firstLetter"
                              className="text-Primary_white text-Font_14 font-sans font-normal text-left block w-full mb-1 whitespace-normal break-words"
                            >
                              {account.txn_id}
                            </p>
                            <p className="text-Primary_grey text-Font_12 font-sans font-normal text-left">
                              Transaction ID
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  {showAdditionalDetails && (
                    <>
                      <div className="flex flex-row items-start gap-x-5">
                        <div
                          className={`my-8 p-5 bg-Blue_5 h-auto rounded-[20px] ${
                            validItems?.length === 0
                              ? "w-2/5"
                              : validItems?.length === 1
                              ? "w-2/6"
                              : validItems?.length === 2
                              ? "w-4/6"
                              : attachments.length > 0
                              ? "w-[676px]"
                              : "w-full"
                          }`}
                        >
                          <p className="text-Primary_grey text-Font_14 text-left font-sans font-semibold mb-5">
                            Additional Details
                          </p>

                          {validItems?.length === 0 ? (
                            <>
                              <p className="text-left text-Primary_grey text-Font_12 font-sans font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </>
                          ) : attachments.length > 0 ? (
                            <div className="mx-auto">
                              {validItems?.map((obj, index) => {
                                if (index % 2 === 0) {
                                  const isLastRow =
                                    index + 2 >= validItems?.length;
                                  const isFirstRow = index === 0;

                                  return (
                                    <div
                                      key={index}
                                      className={`flex flex-row ${
                                        !isFirstRow ? "mt-2.5" : ""
                                      }`}
                                    >
                                      {validItems
                                        .slice(index, index + 2)
                                        .map((subItem, subIndex) => {
                                          const isLastInRow = subIndex === 1;
                                          const nextItemExists =
                                            validItems[index + subIndex + 0] !==
                                            undefined;

                                          if (
                                            subItem?.name !== "Hyperlink" &&
                                            subItem?.name !== "File"
                                          ) {
                                            return (
                                              <>
                                                <div
                                                  key={subIndex}
                                                  className={`flex flex-col w-72 ${
                                                    !isLastRow
                                                      ? "border-b border-solid border-Blue_2"
                                                      : ""
                                                  }`}
                                                >
                                                  {subItem?.value ? (
                                                    <p className="text-Primary_white text-Font_14 text-left font-sans font-normal whitespace-normal break-words">
                                                      {subItem?.data_type ===
                                                        "toggle" &&
                                                      typeof subItem?.value ===
                                                        "boolean" &&
                                                      subItem?.value == true
                                                        ? "Yes"
                                                        : subItem?.data_type ===
                                                            "multi_select_list" &&
                                                          subItem?.value
                                                            .length !== 0
                                                        ? subItem?.value?.join(
                                                            ","
                                                          )
                                                        : subItem?.data_type ===
                                                          "date_range"
                                                        ? (subItem?.value?.start_date).concat(
                                                            " - ",
                                                            subItem?.value
                                                              ?.end_date
                                                          )
                                                        : subItem?.data_type ===
                                                          "from_year_to_year"
                                                        ? (subItem?.value?.from)
                                                            .toString()
                                                            .concat(
                                                              " - ",
                                                              (subItem?.value?.to).toString()
                                                            )
                                                        : typeof subItem?.value !==
                                                            "object" &&
                                                          (subItem?.name !==
                                                            "Hyperlink" ||
                                                            subItem?.name !==
                                                              "File")
                                                        ? subItem.value
                                                        : "Not Given"}
                                                    </p>
                                                  ) : (
                                                    <p className="text-Primary_white text-Font_14 text-left font-sans font-normal capitalize whitespace-normal break-words">
                                                      {subItem?.data_type ===
                                                        "toggle" &&
                                                      subItem.hasOwnProperty(
                                                        "value"
                                                      ) === false
                                                        ? "No"
                                                        : "Not given"}
                                                    </p>
                                                  )}
                                                  <p
                                                    className={`text-Primary_grey text-Font_12 text-left font-sans font-normal mt-1 break-words ${
                                                      !isLastRow ? "mb-2.5" : ""
                                                    }`}
                                                  >
                                                    {subItem?.data_type ===
                                                    "from_year_to_year"
                                                      ? "From year".concat(
                                                          " - ",
                                                          "To year"
                                                        )
                                                      : subItem?.data_type ===
                                                        "date_range"
                                                      ? "From date".concat(
                                                          " - ",
                                                          "To date"
                                                        )
                                                      : subItem?.name !==
                                                          "Hyperlink" ||
                                                        subItem?.name !== "File"
                                                      ? subItem?.name
                                                      : "N/A"}
                                                  </p>
                                                </div>
                                                {!isLastInRow &&
                                                  nextItemExists && (
                                                    <div className="border-r border-solid border-Blue_2 mx-7"></div>
                                                  )}
                                              </>
                                            );
                                          }
                                        })}
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          ) : (
                            <div className="mx-auto">
                              {validItems?.map((obj, index) => {
                                if (index % 3 === 0) {
                                  const isLastRow =
                                    index + 3 >= validItems?.length;
                                  const isFirstRow = index === 0;

                                  return (
                                    <div
                                      key={index}
                                      className={`flex flex-row ${
                                        !isFirstRow ? "mt-2.5" : ""
                                      }`}
                                    >
                                      {validItems
                                        .slice(index, index + 3)
                                        .map((subItem, subIndex) => {
                                          const isLastInRow = subIndex === 2;
                                          const nextItemExists =
                                            validItems[index + subIndex + 1] !==
                                            undefined;
                                          return (
                                            <>
                                              <div
                                                key={subIndex}
                                                className={`flex flex-col w-72 ${
                                                  !isLastRow
                                                    ? "border-b border-solid border-Blue_2"
                                                    : ""
                                                }`}
                                              >
                                                {subItem?.value ? (
                                                  <p className="text-Primary_white text-Font_14 text-left font-sans font-normal whitespace-normal break-words">
                                                    {subItem?.data_type ===
                                                      "toggle" &&
                                                    typeof subItem?.value ===
                                                      "boolean" &&
                                                    subItem?.value == true
                                                      ? "Yes"
                                                      : subItem?.data_type ===
                                                          "multi_select_list" &&
                                                        subItem?.value
                                                          .length !== 0
                                                      ? subItem?.value?.join(
                                                          ","
                                                        )
                                                      : subItem?.data_type ===
                                                        "date_range"
                                                      ? (subItem?.value?.start_date).concat(
                                                          " - ",
                                                          subItem?.value
                                                            ?.end_date
                                                        )
                                                      : subItem?.data_type ===
                                                        "from_year_to_year"
                                                      ? (subItem?.value?.from)
                                                          .toString()
                                                          .concat(
                                                            " - ",
                                                            (subItem?.value?.to).toString()
                                                          )
                                                      : typeof subItem?.value !==
                                                        "object"
                                                      ? subItem.value
                                                      : "Not Given"}
                                                  </p>
                                                ) : (
                                                  <p className="text-Primary_white text-Font_14 text-left font-sans font-normal capitalize whitespace-normal break-words">
                                                    {subItem?.data_type ===
                                                      "toggle" &&
                                                    subItem.hasOwnProperty(
                                                      "value"
                                                    ) === false
                                                      ? "No"
                                                      : "Not given"}
                                                  </p>
                                                )}
                                                <p
                                                  className={`text-Primary_grey text-Font_12 text-left font-sans font-normal mt-1 break-words ${
                                                    !isLastRow ? "mb-2.5" : ""
                                                  }`}
                                                >
                                                  {subItem?.data_type ===
                                                  "from_year_to_year"
                                                    ? "From year".concat(
                                                        " - ",
                                                        "To year"
                                                      )
                                                    : subItem?.data_type ===
                                                      "date_range"
                                                    ? "From date".concat(
                                                        " - ",
                                                        "To date"
                                                      )
                                                    : subItem.name}
                                                </p>
                                              </div>
                                              {!isLastInRow &&
                                                nextItemExists && (
                                                  <div className="border-r border-solid border-Blue_2 mx-7"></div>
                                                )}
                                            </>
                                          );
                                        })}
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          )}
                        </div>
                        {attachments.length > 0 && (
                          <div className="my-8 p-5 h-auto w-[328px] rounded-[20px] bg-Blue_5">
                            <p className="text-Font_14 text-Primary_grey font-sans font-semibold mb-2.5">
                              Attachments
                            </p>
                            {attachments.map((obj) => {
                              if (obj?.name === "Hyperlink") {
                                return (
                                  <>
                                    <div className="flex flex-col gap-y-0.5">
                                      <p className="text-Font_12 text-Primary_grey font-sans font-normal pb-0.5">
                                        URL
                                      </p>
                                      <div className="flex flex-col gap-y-1 w-72 h-28 p-2.5 rounded-[10px] bg-Blue_3">
                                        <div className="flex flex-row items-center w-[268px] h-[54px] p-2.5 rounded-[5px] bg-Blue_5">
                                          <img
                                            src={default_file}
                                            className="w-9 h-8 items-center"
                                          />
                                          <p className="ml-2.5 text-Font_10 text-Primary_grey font-sans font-normal">
                                            N/A
                                          </p>
                                        </div>
                                        <p className="text-Font_10 text-Pending font-sans font-normal url-clamp break-words">
                                          {obj?.value ? (
                                            <Tooltip
                                              componentsProps={{
                                                popper: {
                                                  sx: {
                                                    zIndex: 9999,
                                                    [`& .${tooltipClasses.tooltip}`]:
                                                      {
                                                        backgroundColor: (
                                                          theme
                                                        ) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                    [`& .${tooltipClasses.arrow}`]:
                                                      {
                                                        color: (theme) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                  },
                                                },
                                              }}
                                              title={obj?.value}
                                              arrow
                                              placement="bottom"
                                              PopperProps={{
                                                style: {
                                                  maxWidth: "none",
                                                },
                                              }}
                                            >
                                              <a
                                                href={obj?.value}
                                                target="blank"
                                                className="block h-7"
                                              >
                                                {obj?.value}
                                              </a>
                                            </Tooltip>
                                          ) : (
                                            "Not Given"
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <div className="flex flex-col gap-y-0.5 pt-5">
                                      <p className="text-Font_12 text-Primary_grey font-sans font-normal pb-0.5">
                                        {obj?.value?.metadata?.mime_type ===
                                        "image/png"
                                          ? "Images"
                                          : "Files"}
                                      </p>
                                      <div className="flex flex-row items-center gap-x-2.5 w-72 h-14 p-2.5 rounded-[10px] bg-Blue_3">
                                        <img
                                          src={
                                            // obj?.value?.metadata?.mime_type ===
                                            // "image/png"
                                            default_file
                                            // : require("../../../assets/FileFormatIcons/" +
                                            //     obj?.value?.metadata?.filename
                                            //       .slice(
                                            //         obj?.value?.metadata?.filename.indexOf(
                                            //           "."
                                            //         ) + 1
                                            //       )
                                            //       .toUpperCase() +
                                            //     ".svg")
                                          }
                                          className="w-9 h-8"
                                        />
                                        <div className="flex flex-col gap-y-0.5">
                                          <p className="text-Font_12 text-Primary_white font-sans font-normal capitalize">
                                            {obj?.value?.metadata?.filename}
                                          </p>
                                          <p className="text-Font_10 text-Primary_grey font-sans font-normal capitalize">
                                            {obj?.value?.metadata?.size +
                                              " ." +
                                              obj?.value?.metadata?.filename.slice(
                                                obj?.value?.metadata?.filename.indexOf(
                                                  "."
                                                ) + 1
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {loading ? (
          <div className="bene-detail-loader-box m-auto justify-center items-center flex">
            <Loader />
          </div>
        ) : (
          <div className="internalTxnDetailsPageMob">
            {showDeclineModal && (
              <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[9998] bg-black bg-opacity-80">
                <DeclinedPopup
                  onClose={closeDeclineModal}
                  accountId={internalTxnDetailID}
                  status="internal-transaction"
                  allAccounts={viewInternalTxnDetails}
                  updateAllAccounts={updateAllAccounts}
                  closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                />
              </div>
            )}

            <div className="bg-Blue_6 fixed top-0 left-0 z-50 w-full">
              <div className="w-full flex flex-row items-center">
                <div
                  className="backArrowMobile p-5"
                  onClick={() => navigate(-1)}
                >
                  <img src={arrowLeftimg} alt="arrowleft" className="w-4 h-4" />
                </div>
                <div className="flex flex-col w-full py-2 gap-y-0.5">
                  <div className="text-base text-Primary_white text-left font-sans font-normal leading-[21.79px]">
                    Internal Transaction
                  </div>
                  <div className="text-xs text-Primary_grey text-left font-sans font-semibold leading-[16.34px]">
                    Transaction detail
                  </div>
                </div>
              </div>
            </div>
            {openTransHistory && (
              <div className="fixed top-0 left-0 w-screen h-screen z-[9998] bg-black bg-opacity-80">
                <TransactionHistory
                  owner_account_id={
                    internalTxnData?.transaction?.[0]?.owner_account_id
                  }
                  owner_account_bank_acc_no={
                    internalTxnData?.transaction?.[0]?.owner_account_bank_acc_no
                  }
                  internal_account_confidential={
                    modalType === "Confidential transaction"
                      ? internalTxnData?.transaction?.[0]
                          ?.confidential_transaction
                      : null
                  }
                  txnHistorytype={"internalTxnHistory"}
                  onClose={closeTransactionHistory}
                  popup={modalType}
                />
              </div>
            )}
            <div className=" mt-14 w-full bg-Blue_5">
              {internalTxnData?.transaction?.map((account) => (
                <div key={account.txn_id} className="w-full">
                  <div className="internal_txn_detail_container p-4 border-b border-solid border-Blue_2">
                    <div className="flex flex-row justify-between">
                      <div className="flex flex-col gap-y-1">
                        <div className="flex flex-row gap-x-1">
                          <p className="text-base text-Settled text-left font-sans font-semibold leading-[21.79px]">
                            &#8377; {formatCurrency(account.total_amount)}
                          </p>
                          <div className="relative">
                            <img
                              src={info}
                              className="w-3 h-3 cursor-pointer relative"
                              onClick={showAmountInfo}
                            />
                            <div className="display_480 absolute">
                              {infoBox && (
                                <div
                                  className="infoBox h-auto flex flex-col top-4 z-10 rounded-[20px]"
                                  style={{}}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="h-14 bg-Blue_7 p-5 rounded-t-[20px]">
                                    <div className="flex flex-row justify-between">
                                      <span className="text-xs text-Primary_grey text-right font-sans font-normal leading-[16.34px]">
                                        Transaction amount
                                      </span>
                                      <span className="text-sm text-Settled text-right font-sans font-semibold leading-[19.07px]">
                                        &#8377;{" "}
                                        {formatCurrency(account.total_amount)}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-1 bg-Blue_5 p-5 rounded-b-[20px]">
                                    <div className="flex flex-row justify-between">
                                      <span className=" text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                        Amount debited
                                      </span>
                                      <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                        &#8377;{" "}
                                        {formatCurrency(account.total_amount)}
                                      </span>
                                    </div>
                                    <div className="my-3 flex items-center justify-center ">
                                      <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                    </div>
                                    <div className="flex flex-row justify-between">
                                      <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                        Tax amount
                                      </span>
                                      <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                        &#8377;{" "}
                                        {formatCurrency(account.tax_amount)}
                                      </span>
                                    </div>
                                    <div className="my-3 flex items-center justify-center ">
                                      <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                    </div>
                                    <div className="flex flex-row justify-between">
                                      <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                        Payment charge
                                      </span>
                                      <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                        &#8377;{" "}
                                        {formatCurrency(account.payment_charge)}
                                      </span>
                                    </div>
                                    <div className="my-3 flex items-center justify-center">
                                      <span className="w-4 h-2 text-Primary_white text-2xl">
                                        =
                                      </span>
                                    </div>
                                    <div className="mt-8 border border-solid border-Blue_1"></div>
                                    <div className="flex flex-row justify-between mt-4">
                                      <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                        Amount credited
                                      </span>
                                      <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                        &#8377;{" "}
                                        {formatCurrency(
                                          account.total_amount -
                                            account.tax_amount -
                                            account.payment_charge
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <p className="text-xs text-Primary_grey text-left font-sans font-normal leading-[16.34px] relative">
                          Amount
                          <div className="display_below_480 absolute">
                            {infoBox && (
                              <div
                                className="infoBox h-auto flex flex-col top-4 z-10 rounded-[20px]"
                                style={{}}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="h-14 bg-Blue_7 p-5 rounded-t-[20px]">
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey text-right font-sans font-normal leading-[16.34px]">
                                      Transaction amount
                                    </span>
                                    <span className="text-sm text-Settled text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.total_amount)}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex-1 bg-Blue_5 p-5 rounded-b-[20px]">
                                  <div className="flex flex-row justify-between">
                                    <span className=" text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Amount debited
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.total_amount)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center ">
                                    <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                  </div>
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Tax amount
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.tax_amount)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center ">
                                    <span className="w-3.5 h-0.5 rounded-[2px] bg-Failed_to_take_action"></span>
                                  </div>
                                  <div className="flex flex-row justify-between">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Payment charge
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(account.payment_charge)}
                                    </span>
                                  </div>
                                  <div className="my-3 flex items-center justify-center">
                                    <span className="w-4 h-2 text-Primary_white text-2xl">
                                      =
                                    </span>
                                  </div>
                                  <div className="mt-8 border border-solid border-Blue_1"></div>
                                  <div className="flex flex-row justify-between mt-4">
                                    <span className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                                      Amount credited
                                    </span>
                                    <span className="text-sm text-Primary_white text-right font-sans font-semibold leading-[19.07px]">
                                      &#8377;{" "}
                                      {formatCurrency(
                                        account.total_amount -
                                          account.tax_amount -
                                          account.payment_charge
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </p>
                      </div>
                      <div className="flex flex-col gap-y-1">
                        <p className="text-base text-Primary_white text-right font-sans font-normal leading-[21.79px]">
                          {account.distribution_utr
                            ? account.distribution_utr
                            : "N/A"}
                        </p>
                        <p className="text-xs text-Primary_grey text-right font-sans font-normal leading-[16.34px]">
                          UTR number
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex pt-4 pb-2.5 pl-4 justify-between items-center">
                    <div className="flex items-center w-full justify-between">
                      <div
                        className="p-2 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 rounded-lg -ml-2.5"
                        onClick={() =>
                          navigate(
                            `/accounts/owner/owner_account_details/${account.owner_account_id}`
                          )
                        }
                      >
                        <div className="flex flex-col gap-y-0.5">
                          <div className="flex flex-row items-center gap-x-2.5">
                            <p className="text-base text-Primary_white text-left font-sans font-normal leading-[21.79px]">
                              {formatAccountNumber(
                                account.owner_account_bank_acc_no
                              )}
                            </p>
                            <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-[3px]">
                              <img
                                src={arrowRight}
                                alt="document"
                                className="w-2.5 h-2.5 "
                              />
                            </div>
                          </div>
                          <p className="text-xs text-Primary_grey text-left font-sans font-normal">
                            Source account
                          </p>
                        </div>
                      </div>
                      <div className="bg-Primary_white rounded-tl-[20px] rounded-bl-[20px] flex items-center justify-around h-[2rem] w-[6rem]">
                        <img
                          src={require("../../../assets/IfscLogo/" +
                            IfscCodeMapper(account.owner_account_ifsc_code))}
                          alt="Source account bank name"
                          className="w-14 h-3.5"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-x-2.5 justify-between px-4">
                    <div className="w-[45%] border-b border-solid border-Blue_2"></div>
                    <div className="w-5 h-5">
                      <img src={arrowDownBlueWhite} alt="arrowDownBlueWhite" />
                    </div>
                    <div className="w-[45%] border-b border-solid border-Blue_2"></div>
                  </div>

                  <div className="flex flex-col pt-2.5 pb-4 pl-4 gap-y-4 border-b border-solid border-Blue_2">
                    <div className="flex flex-row justify-between items-center w-full">
                      <div
                        className="p-2 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 rounded-lg -ml-2.5"
                        onClick={() => showToast()}
                      >
                        <div className="flex flex-col gap-y-0.5">
                          <div className="flex flex-row items-center gap-x-2.5">
                            <p className="text-base text-Primary_white text-left font-sans font-normal leading-[21.79px]">
                              {formatAccountNumber(
                                account?.internal_account_bank_acc_no
                              )}
                            </p>
                            <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-[3px]">
                              <img
                                src={arrowRight}
                                alt="document"
                                className="w-2.5 h-2.5 "
                              />
                            </div>
                          </div>
                          <p className="text-xs text-Primary_grey text-left font-sans font-normal leading-[16.34px]">
                            Destination account
                          </p>
                        </div>
                      </div>
                      <div className="bg-Primary_white rounded-tl-[20px] rounded-bl-[20px]  flex items-center justify-around h-[2rem] w-[6rem]">
                        <img
                          src={require("../../../assets/IfscLogo/" +
                            IfscCodeMapper(
                              account?.internal_account_ifsc_code
                            ))}
                          alt="Destination account bank name"
                          className="w-14 h-3.5"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-y-1">
                      <p className="text-Primary_white text-base	font-sans font-normal leading-[21.79px] capitalize">
                        {account?.internal_account_name?.toLowerCase()}
                      </p>
                      <p className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                        Account name
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col p-4 gap-y-1 border-b border-solid border-Blue_2">
                    <p className="text-base text-Primary_white font-sans font-normal leading-[21.79px]">
                      {formatDateViewAll(account?.created_on, true, true)}
                    </p>
                    <p className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                      Initiated on
                    </p>
                  </div>

                  <div className="flex flex-col p-4 gap-y-1 border-b border-solid border-Blue_2">
                    <p className="text-base text-Primary_white font-sans font-normal leading-[21.79px]">
                      {account?.payment_method}
                    </p>
                    <p className="text-xs text-Primary_grey font-sans font-normal leading-[16.34px]">
                      Payment method
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-screen bg-Blue_3">
              <div className="flex flex-col w-full m-auto">
                <div className="flex flex-row w-full m-auto">
                  {viewInternalTxnDetails?.map((account) =>
                    (loadingBox && account.lifecycle_status === "pending") ||
                    internalTxnApprovalLoading ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex justify-center items-center w-full h-[106px] bg-Blue_2">
                            <img
                              src={xpentraloader}
                              className="w-10 h-10 loader"
                            />
                          </div>
                        </div>
                      </>
                    ) : networkError || errorMessage || account.message ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex-grow w-full h-[106px] bg-Failed_to_take_action p-4 space-y-0.5">
                            <div className="flex flex-row h-full">
                              <div className="flex-none w-[10%] mt-2">
                                <img
                                  src={skipping_verification}
                                  className="h-7 w-7"
                                />
                              </div>
                              <div className="flex-1 flex-col space-y-1 ml-2.5">
                                <p className="text-Primary_white text-sm text-left font-sans font-normal">
                                  Failed to take action
                                </p>

                                <Tooltip
                                  componentsProps={{
                                    popper: {
                                      sx: {
                                        [`& .${tooltipClasses.tooltip}`]: {
                                          backgroundColor: (theme) =>
                                            theme.palette.common.black,
                                        },
                                        [`& .${tooltipClasses.arrow}`]: {
                                          color: (theme) =>
                                            theme.palette.common.black,
                                        },
                                      },
                                    },
                                  }}
                                  title={
                                    networkError
                                      ? "An error occurred while taking action on this transaction"
                                      : errorMessage
                                      ? errorMessage
                                      : account.message
                                      ? account.message
                                      : ""
                                  }
                                  arrow
                                  placement="bottom"
                                  PopperProps={{
                                    style: {
                                      maxWidth: "none",
                                    },
                                  }}
                                >
                                  <p className="text-Primary_grey text-xs text-left font-sans font-normal line-clamp">
                                    {networkError
                                      ? "An error occurred while taking action on this transaction"
                                      : errorMessage
                                      ? errorMessage
                                      : account.message
                                      ? account.message
                                      : ""}
                                  </p>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : account.last_updated_status === "Approved" &&
                      account.lifecycle_status === "pending" &&
                      account.last_updated_user_id ===
                        loginid?.employees?.id ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex-grow w-full h-[106px] bg-Blue_5 p-5 space-y-1">
                            <p className="text-Pending text-sm text-left font-sans font-normal">
                              Further approval pending
                            </p>
                            <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                              This transaction has been approved by you, but it
                              requires another user's approval before
                              settlement.
                            </p>
                          </div>
                        </div>
                      </>
                    ) : account.last_updated_status === "Approved" &&
                      account.lifecycle_status === "pending" &&
                      services?.find(
                        (service) => service === "AInternalTxn"
                      ) === undefined ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex-grow w-full h-[106px] bg-Blue_5 p-5 space-y-1">
                            <p className="text-Pending text-sm text-left font-sans font-normal">
                              Further approval pending
                            </p>
                            <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                              This transaction requires another user's approval
                              before settlement.
                            </p>
                          </div>
                        </div>
                      </>
                    ) : account?.lifecycle_status === "rejected" ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex-grow w-full h-[90px] bg-Blue_5 py-[27.5px] px-[15px] space-y-0.5">
                            <p className="text-Failed text-sm text-left font-sans font-semibold">
                              Rejected reason
                            </p>

                            <Tooltip
                              componentsProps={{
                                popper: {
                                  sx: {
                                    [`& .${tooltipClasses.tooltip}`]: {
                                      backgroundColor: (theme) =>
                                        theme.palette.common.black,
                                    },
                                    [`& .${tooltipClasses.arrow}`]: {
                                      color: (theme) =>
                                        theme.palette.common.black,
                                    },
                                  },
                                },
                              }}
                              title={account.rejection_reason}
                              arrow
                              placement="bottom"
                              PopperProps={{
                                style: {
                                  maxWidth: "none",
                                },
                              }}
                            >
                              <p className="text-Primary_grey text-xs font-sans font-normal line-clamp">
                                {account.rejection_reason}
                              </p>
                            </Tooltip>
                          </div>
                        </div>
                      </>
                    ) : account?.internal_account_approval_status ===
                      "pending" ? (
                      <>
                        <div className="w-full flex flex-row">
                          <div className="flex-grow w-full h-auto bg-Blue_5 px-5 py-4">
                            <p className="text-Pending text-sm text-left font-sans font-semibold">
                              Account approval pending
                            </p>
                            <p className="text-Primary_grey text-xs text-left font-sans font-normal mt-1">
                              {services?.find(
                                (service) => service === "AInternalTxn"
                              ) !== undefined
                                ? "Account is not approved, approve account before approving transaction."
                                : "To approve the account, please contact the authorized person."}
                            </p>
                            <div
                              className={`flex justify-between items-center w-[150px] h-7 py-1 px-2.5 mt-2 rounded-[5px] bg-Blue_3 ${
                                services?.find(
                                  (service) => service === "AInternalTxn"
                                ) !== undefined
                                  ? "opacity-100 cursor-pointer hover:bg-gray-200 hover:bg-opacity-20"
                                  : "opacity-50 cursor-not-allowed"
                              }`}
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) => service === "IAAccount"
                                  ) !== undefined
                                ) {
                                  // navigate(
                                  //   `/accounts/internal_account/details/${account?.internal_account_id}`
                                  // );
                                  toast.info(
                                    "Feature coming soon for mobile",
                                    toast_position
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "IAAccount",
                                    },
                                  });
                                }
                              }}
                            >
                              <p className="text-xs text-Primary_white font-sans font-regular">
                                {/* solving conflict */}
                                Approve Account
                              </p>
                              <img
                                src={arrow_right_white_filled}
                                className="w-3 h-3"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    ) : account?.internal_account_approval_status ===
                        "approved" && account.lifecycle_status === "pending" ? (
                      <>
                        <div className="w-full flex flex-row bg-Blue_2">
                          <div
                            className={`flex flex-row w-full h-[106px] overflow-hidden ${
                              checkInternalTransaction
                                ? "opacity-100"
                                : "opacity-50"
                            }`}
                          >
                            <div
                              className={`w-1/2 h-[105px] bg-Button_red  flex flex-col justify-center place-items-center space-y-1 ${
                                checkInternalTransaction
                                  ? "hover:opacity-80 cursor-pointer"
                                  : "cursor-not-allowed"
                              }`}
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) => service === "AInternalTxn"
                                  ) !== undefined &&
                                  checkInternalTransaction
                                ) {
                                  handleDeclinedDetails(account.txn_id);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AInternalTxn",
                                    },
                                  });
                                }
                              }}
                            >
                              <img
                                src={declineImage}
                                className="w-[40px] h-[40px]"
                              />
                              <p className="text-Primary_white text-xs text-center font-sans font-normal">
                                Reject
                              </p>
                            </div>
                            <div
                              className={`w-1/2 h-[105px] bg-Button_green flex flex-col justify-center place-items-center space-y-1 ${
                                checkInternalTransaction
                                  ? "hover:opacity-80 cursor-pointer"
                                  : " cursor-not-allowed"
                              }`}
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) => service === "AInternalTxn"
                                  ) !== undefined &&
                                  checkInternalTransaction
                                ) {
                                  handleApproveInternalTransaction(
                                    account.txn_id
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AInternalTxn",
                                    },
                                  });
                                }
                              }}
                            >
                              <img
                                src={approveImage}
                                className="w-[40px] h-[40px]"
                              />
                              <p className="text-Primary_white text-xs text-center font-sans font-normal">
                                Approve
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )
                  )}
                </div>

                <div className="flex flex-col w-full my-5">
                  <div className="py-2.5 px-4 bg-Blue_5 text-sm text-Primary_white text-left font-sans font-semibold leading-[19.07px]">
                    Quick Action
                  </div>
                  <div className="w-full flex flex-row bg-Blue_7 items-center h-[96px] border-b border-Blue_2">
                    <div
                      className="w-full h-full py-[10px] cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 flex flex-col justify-center place-items-center space-y-1"
                      onClick={() => {
                        //FIXME: can actions be restricted in mobile mode?
                        openTransactionHistory();
                        setModalType("Transaction history");
                      }}
                      // onClick={() => { showToast();
                      // }}
                    >
                      <img
                        src={transactionHistory}
                        className="w-[38px] h-[38px]"
                      />
                      <p className="text-Primary_white text-[12px] text-center font-sans font-normal leading-[16.34px] w-[69px]">
                        Transaction history
                      </p>
                    </div>
                    {hasConfidential &&
                      internalTxnData?.transaction?.[0]
                        ?.confidential_transaction === "Y" && (
                        <div className="border border-solid border-Blue_3 h-full"></div>
                      )}
                    {hasConfidential &&
                    internalTxnData?.transaction?.[0]
                      ?.confidential_transaction === "Y" ? (
                      <>
                        <div
                          className="w-full h-full py-[10px] cursor-pointer hover:bg-gray-200 hover:bg-opacity-20 flex flex-col justify-center place-items-center space-y-1"
                          onClick={() => {
                            openTransactionHistory();
                            setModalType("Confidential transaction");
                          }}
                        >
                          <img
                            src={confidential_transactionImg}
                            className="w-[38px] h-[38px]"
                          />
                          <p className="text-Primary_white text-[12px] text-center font-sans font-normal leading-[16.34px] w-[69px]">
                            Confidential transactions
                          </p>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div
                  className={`flex flex-col w-full h-auto overflow-hidden relative ${
                    internalTxnData?.transaction?.[0]
                      ?.distribution_lifecycle_status ===
                      "distribution_complete" ||
                    internalTxnData?.transaction?.[0]?.lifecycle_status ===
                      "abandoned" ||
                    (internalTxnData?.transaction?.[0]?.lifecycle_status ===
                      "approved" &&
                      internalTxnData?.transaction?.[0]
                        ?.internal_account_approval_status !== "pending")
                      ? "bg-Blue_3"
                      : "bg-Blue_2"
                  }`}
                >
                  <div className="py-[8.5px] pl-[15px] bg-Blue_5">
                    <p className="text-Primary_grey text-[16px] text-left font-sans font-semibold">
                      Transaction Timeline
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <div
                      className="Approval-box w-full cursor-pointer bg-Blue_7 p-[15px]"
                      onClick={() => {
                        setShowApprovalTimeline(!showApprovalTimeline);
                        if (!showApprovalTimeline) {
                          setShowDetails(true);
                          setShowAdditionalDetails(false);
                          setShowDistributionTimeline(false);
                        }
                        setOpenDistributionTimeline(false);
                      }}
                    >
                      <div className="flex flex-row justify-between">
                        {viewInternalTxnDetails?.length >= 1 &&
                          viewInternalTxnDetails?.map((account) =>
                            account?.lifecycle_status === "rejected" ? (
                              <>
                                <p className="text-Failed text-sm text-left capitalize font-sans font-semibold">
                                  {account.lifecycle_status}
                                </p>
                              </>
                            ) : account?.lifecycle_status === "approved" ? (
                              <>
                                <p className="text-Awaiting text-sm text-left capitalize font-sans font-semibold">
                                  {account.lifecycle_status}
                                </p>
                              </>
                            ) : account?.lifecycle_status === "abandoned" ? (
                              <>
                                <p className="text-Abandoned text-sm text-left capitalize font-sans font-semibold">
                                  {account.lifecycle_status}
                                </p>
                              </>
                            ) : account.last_updated_status === "Approved" &&
                              account.last_updated_user_id ===
                                loginid?.employees?.id ? (
                              <>
                                <p className="text-Pending text-sm text-left font-sans font-semibold">
                                  Pending
                                </p>
                              </>
                            ) : (
                              <>
                                <p className="text-Pending text-sm text-left font-sans font-semibold">
                                  {services?.find(
                                    (service) => service === "AInternalTxn"
                                  ) === undefined
                                    ? "Pending"
                                    : "Require approval"}
                                </p>
                              </>
                            )
                          )}
                        <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                          <img
                            src={showApprovalTimeline ? arrow_up : arrow_down}
                            alt="document"
                            className="w-2.5 h-2.5 "
                          />
                        </div>
                      </div>
                      <div className="flex flex-row items-center justify-between mt-[2px]">
                        <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                          Status
                        </p>
                        <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                          Stage 1 - Approval
                        </p>
                      </div>
                    </div>
                    <div
                      className={`Distribution-box w-full  p-[15px] ${
                        viewInternalTxnDetails?.length >= 1 &&
                        viewInternalTxnDetails?.[0]
                          ?.distribution_lifecycle_status
                          ? "bg-Blue_7 hover:bg-Blue_7 cursor-pointer"
                          : "bg-Blue_7 cursor-default"
                      }`}
                      onClick={
                        viewInternalTxnDetails?.length >= 1 &&
                        viewInternalTxnDetails?.[0]
                          ?.distribution_lifecycle_status
                          ? handleDistributionClick
                          : null
                      }
                    >
                      <div className="flex flex-row justify-between">
                        {viewInternalTxnDetails?.map((account) =>
                          account?.distribution_lifecycle_status ===
                          "distribution_complete" ? (
                            <>
                              <p className="text-Settled text-sm text-left font-sans font-semibold opacity-100">
                                Distribution complete
                              </p>
                            </>
                          ) : account?.distribution_lifecycle_status ===
                              "rejected" ||
                            account?.distribution_lifecycle_status ===
                              "failed" ? (
                            <>
                              <p className="text-Failed text-sm text-left font-sans font-semibold opacity-100">
                                {`Distribution ${account?.distribution_lifecycle_status}`}
                              </p>
                            </>
                          ) : account?.distribution_lifecycle_status ===
                            "abandoned" ? (
                            <>
                              <p className="text-Abandoned text-sm text-left font-sans font-semibold opacity-100">
                                {"Distribution".concat(
                                  " ",
                                  account.distribution_lifecycle_status
                                )}
                              </p>
                            </>
                          ) : account?.distribution_lifecycle_status ? (
                            <>
                              <p className="text-Queued text-sm text-left font-sans font-semibold opacity-100">
                                {account.distribution_lifecycle_status ===
                                "created"
                                  ? "Distribution created"
                                  : account.distribution_lifecycle_status ===
                                    "approved"
                                  ? "Distribution approved"
                                  : account.distribution_lifecycle_status ===
                                    "awaiting_funds"
                                  ? "Awaiting funds"
                                  : account.distribution_lifecycle_status ===
                                    "distribution_initiated"
                                  ? "Distribution initiated"
                                  : account.distribution_lifecycle_status}
                              </p>
                            </>
                          ) : (
                            <>
                              <p
                                className={`${
                                  account?.distribution_lifecycle_status
                                    ? "opacity-100 text-Queued"
                                    : "opacity-50 text-Primary_white"
                                } text-sm text-left font-sans font-semibold`}
                              >
                                {account?.distribution_lifecycle_status
                                  ? account?.distribution_lifecycle_status
                                  : "N/A"}
                              </p>
                            </>
                          )
                        )}
                        <div className="grid place-content-center w-5 h-5 bg-Blue_3 rounded-md">
                          <img
                            src={
                              showDistributionTimeline ? arrow_up : arrow_down
                            }
                            alt="document"
                            className={`w-2.5 h-2.5 ${
                              viewInternalTxnDetails?.length >= 1 &&
                              viewInternalTxnDetails?.[0]
                                ?.distribution_lifecycle_status
                                ? "opacity-100"
                                : "opacity-50"
                            }`}
                          />
                        </div>
                      </div>
                      <div className="flex flex-row justify-between items-center mt-[2px]">
                        <p
                          className={`text-Primary_grey text-[12px] text-left font-sans font-normal ${
                            internalTxnData?.transaction?.[0]
                              ?.distribution_lifecycle_status
                              ? "opacity-100"
                              : "opacity-50"
                          }`}
                        >
                          Status
                        </p>
                        <p
                          className={`text-Primary_grey text-[12px] text-left font-sans font-normal ${
                            viewInternalTxnDetails?.length >= 1 &&
                            viewInternalTxnDetails?.[0]
                              ?.distribution_lifecycle_status
                              ? "opacity-100"
                              : "opacity-50"
                          }`}
                        >
                          Stage 2 - Distribution
                        </p>
                      </div>
                    </div>
                    <div className="bg-Blue_5">
                      <div className="border border-solid border-Blue_2 h-16"></div>
                    </div>
                  </div>
                  {viewInternalTxnDetails?.length >= 1 &&
                    viewInternalTxnDetails?.map((account) =>
                      account?.lifecycle_status === "rejected" ? (
                        <>
                          <div className="px-5 h-3 absolute w-full top-[203px] mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-rejected-approval absolute top-0.5 left-0 px-0.5 pt-px"
                                value={0.5}
                              />
                            </div>
                          </div>
                        </>
                      ) : account?.distribution_lifecycle_status ===
                          "rejected" ||
                        account?.distribution_lifecycle_status === "failed" ? (
                        <>
                          <div className="px-5 h-[13.5px] absolute w-full top-[203px] mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-rejected-approval absolute top-0.5 left-0 px-0.5 pt-px"
                                value={1}
                              />
                            </div>
                          </div>
                        </>
                      ) : account?.lifecycle_status === "abandoned" ||
                        account?.distribution_lifecycle_status ===
                          "abandoned" ? (
                        <>
                          <div className="px-5 h-[13.5px]  absolute w-full top-[203px] mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-abandoned-transaction absolute top-0.5 left-0 px-0.5 pt-px"
                                value={`${
                                  account?.lifecycle_status === "abandoned"
                                    ? 0.5
                                    : account?.distribution_lifecycle_status ===
                                      "abandoned"
                                    ? 1
                                    : 0.5
                                }`}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="px-5 h-[13.5px]  absolute w-full top-[203px] mt-1.5">
                            <div className="bg-Blue_2 w-full h-full rounded-[15px] relative">
                              <progress
                                className="w-full h-2 progress-require-approval absolute top-0.5 left-0 px-0.5 pt-px"
                                value={`${
                                  account?.distribution_lifecycle_status ===
                                  "distribution_complete"
                                    ? 1
                                    : account?.distribution_lifecycle_status
                                    ? 0.75
                                    : 0.25
                                }`}
                              />
                            </div>
                          </div>
                        </>
                      )
                    )}
                </div>
              </div>
            </div>

            {showApprovalTimeline ? (
              <>
                <div className="bg-Blue_3 py-[40px] px-[20px] approvalTimelineMob">
                  {viewInternalTxnDetails?.length >= 1 &&
                    [...viewInternalTxnDetails?.[0]?.logs]
                      ?.reverse()
                      .map((account, index) => {
                        const trackCount =
                          (index + 1) %
                            viewInternalTxnDetails?.[0]?.logs?.length ===
                          0;
                        const logs_length =
                          viewInternalTxnDetails?.[0]?.logs?.length;
                        const num = index + 1;
                        return (
                          <>
                            <div
                              key={index}
                              className="flex fex-row items-start w-full max-w-5xl space-x-5 relative"
                            >
                              <div
                                className={`absolute border-l-2 border-solid border-Blue_7 approval_timeline_line ${
                                  num === logs_length
                                    ? "h-10 duration-500 ease-in-out"
                                    : openApprovalTimeline[index]
                                    ? "h-full duration-500 ease-in-out"
                                    : "h-full duration-500 ease-in-out"
                                }`}
                              >
                                <div className="absolute flex flex-row w-full">
                                  <img
                                    src={timeline_dot}
                                    className="w-5 h-5 mt-[36px] ml-[-10px]"
                                  />
                                  <div className="w-2 border-t-2 mt-[2.8rem] ml-[2px] border-solid border-Blue_7"></div>
                                </div>

                                {showApprovalTimeline && num === 1 && (
                                  <>
                                    <div className="absolute border-l-2 border-solid border-Blue_7 h-6 ml-[-1.75px] -mt-6"></div>
                                    <div className="absolute border-t-2 border-solid border-Blue_7 w-36 ml-0 -mt-6"></div>
                                    <div className="absolute border-r-2 border-solid border-Blue_7 h-[18px] ml-36 -mt-10"></div>
                                  </>
                                )}
                              </div>

                              <div
                                className={`flex flex-col w-full px-[20px] py-[15px] rounded-[15px] bg-Blue_5 hover:bg-gray-200 hover:bg-opacity-20 cursor-pointer overflow-hidden approval-data ${
                                  openApprovalTimeline[index]
                                    ? "h-auto"
                                    : "h-100"
                                }`}
                                onClick={() => handleApprovalTimeline(index)}
                              >
                                <div className="flex flex-col items-center">
                                  <div className="flex flex-row justify-between items-center w-full">
                                    <div className="flex flex-col gap-[4px]">
                                      <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                        {account.action === "Add Status"
                                          ? account.remark.toLowerCase()
                                          : account.action.toLowerCase()}
                                      </p>
                                      <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                                        Action
                                      </p>
                                    </div>
                                    <div className="grid place-content-center w-[25px] h-[25px] bg-Blue_3 rounded-md">
                                      <img
                                        src={
                                          openApprovalTimeline[index]
                                            ? arrow_up
                                            : arrow_down
                                        }
                                        alt="document"
                                        className="w-2.5 h-2.5 "
                                      />
                                    </div>
                                  </div>

                                  <div className="flex flex-col items-start w-full gap-[15px] mt-[15px]">
                                    {account?.browser_name && (
                                      <div className="flex flex-row items-center justify-between w-full">
                                        <div className="flex flex-col gap-[4px]">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.browser_name ===
                                            "Microsoft Edge (Chromium)"
                                              ? "Microsoft Edge"
                                              : account.browser_name}
                                          </p>
                                          <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                                            Browser
                                          </p>
                                        </div>
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayBrowser(
                                              account?.browser_name
                                            ) +
                                            ".svg")}
                                          alt="Browser"
                                          className="w-[25px] h-[25px]"
                                        />
                                      </div>
                                    )}
                                    {account?.platform && (
                                      <div className="flex flex-row items-center w-full justify-between">
                                        <div className="flex flex-col gap-[4px]">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.platform}
                                          </p>
                                          <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                                            Platform
                                          </p>
                                        </div>
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayPlatform(account?.platform) +
                                            ".svg")}
                                          alt="Platform"
                                          className="w-[25px] h-[25px]"
                                        />
                                      </div>
                                    )}
                                    {account?.os_version && (
                                      <div className="flex flex-row items-center w-full justify-between">
                                        <div className="flex flex-col gap-[4px]">
                                          <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                            {account?.os_version}
                                          </p>
                                          <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                                            Operating system
                                          </p>
                                        </div>
                                        <img
                                          src={require("../../../assets/Timeline/" +
                                            displayOS(account?.os_version) +
                                            ".svg")}
                                          alt="OS version"
                                          className="w-[25px] h-[25px]"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {openApprovalTimeline[index] && (
                                  <>
                                    <div className="mt-[15px] border border-Blue_2"></div>
                                    <div className="mt-[15px]">
                                      {renderApprovalData(account)}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            {num !== logs_length && (
                              <>
                                <div className="max-w-5xl m-auto h-5 border-l-2 border-solid border-Blue_7"></div>
                              </>
                            )}
                          </>
                        );
                      })}
                </div>
              </>
            ) : showDistributionTimeline ? (
              <>
                <div className="bg-Blue_3 py-[40px] px-[20px] distributionTimelineMob">
                  {viewInternalTxnDetails?.length >= 1 &&
                    [...viewInternalTxnDetails?.[0]?.distribution_logs]
                      ?.reverse()
                      .map((account, index) => {
                        const trackCount =
                          (index + 1) %
                            viewInternalTxnDetails?.[0]?.distribution_logs
                              ?.length ===
                          0;
                        const distributionLogs_length =
                          viewInternalTxnDetails?.[0]?.distribution_logs
                            ?.length;
                        const num = index + 1;
                        return (
                          <>
                            <div
                              key={index}
                              className="flex flex-row items-start w-full max-w-5xl m-auto space-x-5 relative"
                            >
                              <div
                                className={`absolute border-l-2 border-solid border-Blue_7 w-[20px] ${
                                  num === distributionLogs_length
                                    ? "h-10 duration-500 ease-in-out"
                                    : openDistributionTimeline[index]
                                    ? "h-full duration-500 ease-in-out"
                                    : "h-20 duration-500 ease-in-out"
                                }`}
                              >
                                <div className="absolute flex flex-row w-full">
                                  <img
                                    src={timeline_dot}
                                    className="w-5 h-5 mt-[39px] ml-[-10px]"
                                  />
                                  <div className="w-6 border-t-2 mt-[3rem] ml-[3.3px] border-solid border-Blue_7"></div>
                                </div>

                                {showDistributionTimeline && num === 1 && (
                                  <>
                                    <div className="absolute border-l-2 border-solid border-Blue_7 h-6 ml-[-1.75px] -mt-6"></div>
                                    <div className="absolute border-t-2 border-solid border-Blue_7 w-96 ml-0 -mt-6"></div>
                                    <div className="absolute border-r-2 border-solid border-Blue_7 h-[18px] ml-96 -mt-10"></div>
                                  </>
                                )}
                              </div>
                              <div
                                className={`flex flex-col w-full px-5 py-5 rounded-[15px] bg-Blue_5 hover:bg-gray-200 hover:bg-opacity-20 cursor-pointer overflow-hidden distribution-data ${
                                  openDistributionTimeline[index]
                                    ? "h-auto"
                                    : "h-18"
                                }`}
                                onClick={() =>
                                  handleDistributionTimeline(index)
                                }
                              >
                                <div className="flex flex-row justify-between items-center">
                                  <div className="flex flex-row items-center">
                                    <div className="flex flex-col space-y-1 ml-2">
                                      <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                        {account.action === "Add Status"
                                          ? account.remark.toLowerCase()
                                          : account.action.toLowerCase()}
                                      </p>
                                      <p className="text-Primary_grey text-[12px] text-left font-sans font-normal">
                                        Action
                                      </p>
                                    </div>
                                  </div>
                                  <div className="grid place-content-center w-[25px] h-[25px] bg-Blue_3 rounded-md">
                                    <img
                                      src={
                                        openDistributionTimeline[index]
                                          ? arrow_up
                                          : arrow_down
                                      }
                                      alt="document"
                                      className="w-2.5 h-2.5 "
                                    />
                                  </div>
                                </div>
                                {openDistributionTimeline[index] && (
                                  <>
                                    <div className="mt-[15px]">
                                      {renderDistributionData(account)}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            {num !== distributionLogs_length && (
                              <>
                                <div className="max-w-5xl m-auto h-5 border-l-2 border-solid border-Blue_7"></div>
                              </>
                            )}
                          </>
                        );
                      })}
                </div>
              </>
            ) : (
              <div className="details-div-trans mb-5 mt-[20px] bg-Blue_3 w-screen">
                <div className="detail-section-trans h-auto bg-Blue_3 m-auto max-w-5xl">
                  <div className="buttonsfordetails w-full">
                    <button
                      className={`DetailsButton w-1/2 h-10 ${
                        showDetails ? "effective" : "hover:bg-Detail_chip_hover"
                      }`}
                      onClick={toggleDetails}
                    >
                      <span
                        className={`text-[14px] leading-[19.07px] text-center font-sans font-normal ${
                          showDetails
                            ? "text-Blue_5 font-semibold"
                            : "text-Primary_white"
                        } `}
                      >
                        Details
                      </span>
                    </button>
                    <button
                      className={`AdditionalDetailsButton w-1/2 h-10 ${
                        showAdditionalDetails
                          ? "effective"
                          : "hover:bg-Detail_chip_hover"
                      }`}
                      onClick={toggleAdditionalDetails}
                    >
                      <span
                        className={`text-[14px] text-center leading-[19.07px]  font-sans font-normal ${
                          showAdditionalDetails
                            ? "text-Blue_5 font-semibold"
                            : "text-Primary_white"
                        }`}
                      >
                        Additional details
                      </span>
                    </button>
                  </div>
                  {showDetails &&
                    viewInternalTxnDetails?.map((account) => (
                      <div
                        className={`flex flex-col py-5 px-4 ${
                          account?.distribution_lifecycle_status ===
                          "distribution_complete"
                            ? "justify-between"
                            : "space-y-5"
                        }`}
                      >
                        <div
                          className="
                           w-full
                        h-auto p-[15px] rounded-[20px] bg-Blue_5 self-start"
                        >
                          <p className="text-Primary_grey text-sm text-left font-sans font-semibold pb-5">
                            Origin Details
                          </p>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  [`& .${tooltipClasses.arrow}`]: {
                                    color: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={
                              account?.logs?.[0]?.first_name +
                              " " +
                              account?.logs?.[0]?.last_name[0].toUpperCase() +
                              account?.logs?.[0]?.last_name.slice(1)
                            }
                            arrow
                            placement="bottom"
                            PopperProps={{
                              style: {
                                maxWidth: "none",
                              },
                            }}
                          >
                            <p className="text-Primary_white text-sm text-left font-sans font-normal mb-1 truncate">
                              {account?.logs?.[0]?.first_name +
                                " " +
                                account?.logs?.[0]?.last_name[0].toUpperCase() +
                                account?.logs?.[0]?.last_name.slice(1)}
                            </p>
                          </Tooltip>
                          <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                            Initiated by
                          </p>
                        </div>

                        {account?.distribution_lifecycle_status ===
                        "distribution_complete" ? (
                          <>
                            <div
                              className="
                           w-full
                        h-auto px-7 py-5 rounded-[20px] bg-Blue_5"
                            >
                              <p className="text-Primary_grey text-sm text-left font-sans font-semibold pb-5">
                                Settlement Details
                              </p>
                              <p className="text-Primary_white text-sm text-left font-sans font-normal mb-1">
                                {account?.distribution_credited_at
                                  ? ISO_DataFormatter(
                                      account?.distribution_credited_at
                                    )
                                  : "N/A"}
                              </p>
                              <p className="text-Primary_grey text-xs text-left font-sans font-normal border-b border-solid border-Blue_2 pb-2.5">
                                Settled on
                              </p>
                              <p className="text-Primary_white text-sm text-left font-sans font-normal pt-2.5 mb-1 block w-full truncate">
                                <Tooltip
                                  componentsProps={{
                                    popper: {
                                      sx: {
                                        [`& .${tooltipClasses.tooltip}`]: {
                                          backgroundColor: (theme) =>
                                            theme.palette.common.black,
                                        },
                                        [`& .${tooltipClasses.arrow}`]: {
                                          color: (theme) =>
                                            theme.palette.common.black,
                                        },
                                      },
                                    },
                                  }}
                                  title={account.distribution_settlement_id}
                                  arrow
                                  placement="bottom"
                                  PopperProps={{
                                    style: {
                                      maxWidth: "none",
                                    },
                                  }}
                                >
                                  <p className="text-Primary_white text-sm font-sans font-normal text-left truncate block w-full mb-1">
                                    {account?.distribution_settlement_id
                                      ? account?.distribution_settlement_id
                                      : "N/A"}
                                  </p>
                                </Tooltip>
                              </p>
                              <p className="text-Primary_grey text-xs text-left font-sans font-normal">
                                Settlement ID
                              </p>
                            </div>
                            <div className="w-[328px] h-auto px-7 py-5 rounded-[20px] bg-Blue_5">
                              <p className="text-sm text-Primary_grey text-left font-sans font-semibold pb-5">
                                Support Information
                              </p>

                              <p
                                id="id-firstLetter"
                                className="text-Primary_white text-sm font-sans font-normal text-left block w-full mb-1"
                              >
                                {account.txn_id}
                              </p>

                              <p className="text-Primary_grey text-xs font-sans font-normal text-left">
                                Transaction ID
                              </p>
                            </div>
                          </>
                        ) : (
                          <div className="w-full h-auto p-[15px] rounded-[20px] bg-Blue_5">
                            <p className="text-sm text-Primary_grey text-left font-sans font-semibold pb-5">
                              Support Information
                            </p>

                            <p
                              id="id-firstLetter"
                              className="text-Primary_white text-sm font-sans font-normal text-left block w-full mb-1"
                            >
                              {account.txn_id}
                            </p>
                            <p className="text-Primary_grey text-xs font-sans font-normal text-left">
                              Transaction ID
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  {showAdditionalDetails && (
                    <>
                      <div className="flex flex-col items-start py-5 px-4 space-y-5">
                        <div
                          className={`p-[15px] bg-Blue_5 h-auto rounded-[20px] ${
                            validItems?.length === 0
                              ? "w-2/5"
                              : validItems?.length === 1
                              ? "w-2/6"
                              : validItems?.length === 2
                              ? "w-4/6"
                              : attachments.length > 0
                              ? "w-full"
                              : "w-full"
                          }`}
                        >
                          <p className="text-Primary_grey text-sm text-left font-sans font-semibold">
                            Additional Details
                          </p>

                          {validItems?.length === 0 ? (
                            <>
                              <p className="text-left text-Primary_grey text-xs font-sans font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </>
                          ) : attachments.length > 0 ? (
                            <div className="mx-auto">
                              {validItems?.map((obj, index) => {
                                if (index % 2 === 0) {
                                  const isLastRow =
                                    index + 2 >= validItems?.length;
                                  const isFirstRow = index === 0;

                                  return (
                                    <div
                                      key={index}
                                      className={`flex flex-col ${
                                        !isFirstRow ? "mt-2.5" : ""
                                      }`}
                                    >
                                      {validItems
                                        .slice(index, index + 2)
                                        .map((subItem, subIndex) => {
                                          const isLastInRow = subIndex === 1;
                                          const nextItemExists =
                                            validItems[index + subIndex + 0] !==
                                            undefined;

                                          if (
                                            subItem?.name !== "Hyperlink" &&
                                            subItem?.name !== "File"
                                          ) {
                                            return (
                                              <>
                                                <div
                                                  key={subIndex}
                                                  className={`flex flex-col w-full my-[15px] ${
                                                    !isLastRow
                                                      ? "border-b border-solid border-Blue_2"
                                                      : ""
                                                  }`}
                                                >
                                                  {subItem?.value ? (
                                                    <Tooltip
                                                      componentsProps={{
                                                        popper: {
                                                          sx: {
                                                            [`& .${tooltipClasses.tooltip}`]:
                                                              {
                                                                backgroundColor:
                                                                  (theme) =>
                                                                    theme
                                                                      .palette
                                                                      .common
                                                                      .black,
                                                              },
                                                            [`& .${tooltipClasses.arrow}`]:
                                                              {
                                                                color: (
                                                                  theme
                                                                ) =>
                                                                  theme.palette
                                                                    .common
                                                                    .black,
                                                              },
                                                          },
                                                        },
                                                      }}
                                                      title={
                                                        subItem?.data_type ===
                                                          "toggle" &&
                                                        typeof subItem?.value ===
                                                          "boolean" &&
                                                        subItem?.value == true
                                                          ? "Yes"
                                                          : subItem?.data_type ===
                                                              "multi_select_list" &&
                                                            subItem?.value
                                                              .length !== 0
                                                          ? subItem?.value?.join(
                                                              ","
                                                            )
                                                          : subItem?.data_type ===
                                                            "date_range"
                                                          ? (subItem?.value?.start_date).concat(
                                                              " - ",
                                                              subItem?.value
                                                                ?.end_date
                                                            )
                                                          : subItem?.data_type ===
                                                            "from_year_to_year"
                                                          ? (subItem?.value?.from)
                                                              .toString()
                                                              .concat(
                                                                " - ",
                                                                (subItem?.value?.to).toString()
                                                              )
                                                          : typeof subItem?.value ===
                                                            "object"
                                                          ? "Not Given"
                                                          : subItem.value
                                                      }
                                                      placement="bottom-start"
                                                      PopperProps={{
                                                        modifiers: [
                                                          {
                                                            name: "offset",
                                                            options: {
                                                              offset: [-5, -10],
                                                            },
                                                          },
                                                        ],
                                                      }}
                                                    >
                                                      <p className="text-Primary_white text-sm text-left font-sans font-normal truncate">
                                                        {subItem?.data_type ===
                                                          "toggle" &&
                                                        typeof subItem?.value ===
                                                          "boolean" &&
                                                        subItem?.value == true
                                                          ? "Yes"
                                                          : subItem?.data_type ===
                                                              "multi_select_list" &&
                                                            subItem?.value
                                                              .length !== 0
                                                          ? subItem?.value?.join(
                                                              ","
                                                            )
                                                          : subItem?.data_type ===
                                                            "date_range"
                                                          ? (subItem?.value?.start_date).concat(
                                                              " - ",
                                                              subItem?.value
                                                                ?.end_date
                                                            )
                                                          : subItem?.data_type ===
                                                            "from_year_to_year"
                                                          ? (subItem?.value?.from)
                                                              .toString()
                                                              .concat(
                                                                " - ",
                                                                (subItem?.value?.to).toString()
                                                              )
                                                          : typeof subItem?.value !==
                                                              "object" &&
                                                            (subItem?.name !==
                                                              "Hyperlink" ||
                                                              subItem?.name !==
                                                                "File")
                                                          ? subItem.value
                                                          : "Not Given"}
                                                      </p>
                                                    </Tooltip>
                                                  ) : (
                                                    <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                                      {subItem?.data_type ===
                                                        "toggle" &&
                                                      subItem.hasOwnProperty(
                                                        "value"
                                                      ) === false
                                                        ? "No"
                                                        : "Not given"}
                                                    </p>
                                                  )}
                                                  <p
                                                    className={`text-Primary_grey text-xs text-left font-sans font-normal mt-1 ${
                                                      !isLastInRow
                                                        ? "mb-2.5"
                                                        : ""
                                                    }`}
                                                  >
                                                    {subItem?.data_type ===
                                                    "from_year_to_year"
                                                      ? "From year".concat(
                                                          " - ",
                                                          "To year"
                                                        )
                                                      : subItem?.data_type ===
                                                        "date_range"
                                                      ? "From date".concat(
                                                          " - ",
                                                          "To date"
                                                        )
                                                      : subItem?.name !==
                                                          "Hyperlink" ||
                                                        subItem?.name !== "File"
                                                      ? subItem?.name
                                                      : "N/A"}
                                                  </p>
                                                </div>
                                                {!isLastInRow &&
                                                  nextItemExists && (
                                                    <div className="border-r border-solid border-Blue_2 mx-7"></div>
                                                  )}
                                              </>
                                            );
                                          }
                                        })}
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          ) : (
                            <div className="mx-auto">
                              {validItems?.map((obj, index) => {
                                if (index % 3 === 0) {
                                  const isLastRow =
                                    index + 3 >= validItems?.length;
                                  const isFirstRow = index === 0;

                                  return (
                                    <div
                                      key={index}
                                      className={`flex flex-col ${
                                        !isFirstRow ? "mt-2.5" : ""
                                      }`}
                                    >
                                      {validItems
                                        .slice(index, index + 3)
                                        .map((subItem, subIndex) => {
                                          const isLastInRow = subIndex === 2;
                                          const nextItemExists =
                                            validItems[index + subIndex + 1] !==
                                            undefined;
                                          return (
                                            <>
                                              <div
                                                key={subIndex}
                                                className={`flex flex-col w-full py-[15px] ${
                                                  !isLastRow
                                                    ? "border-b border-solid border-Blue_2"
                                                    : ""
                                                }`}
                                              >
                                                {subItem?.value ? (
                                                  <Tooltip
                                                    componentsProps={{
                                                      popper: {
                                                        sx: {
                                                          [`& .${tooltipClasses.tooltip}`]:
                                                            {
                                                              backgroundColor: (
                                                                theme
                                                              ) =>
                                                                theme.palette
                                                                  .common.black,
                                                            },
                                                          [`& .${tooltipClasses.arrow}`]:
                                                            {
                                                              color: (theme) =>
                                                                theme.palette
                                                                  .common.black,
                                                            },
                                                        },
                                                      },
                                                    }}
                                                    title={
                                                      subItem?.data_type ===
                                                        "toggle" &&
                                                      typeof subItem?.value ===
                                                        "boolean" &&
                                                      subItem?.value == true
                                                        ? "Yes"
                                                        : subItem?.data_type ===
                                                            "multi_select_list" &&
                                                          subItem?.value
                                                            .length !== 0
                                                        ? subItem?.value?.join(
                                                            ","
                                                          )
                                                        : subItem?.data_type ===
                                                          "date_range"
                                                        ? (subItem?.value?.start_date).concat(
                                                            " - ",
                                                            subItem?.value
                                                              ?.end_date
                                                          )
                                                        : subItem?.data_type ===
                                                          "from_year_to_year"
                                                        ? (subItem?.value?.from)
                                                            .toString()
                                                            .concat(
                                                              " - ",
                                                              (subItem?.value?.to).toString()
                                                            )
                                                        : typeof subItem?.value ===
                                                          "object"
                                                        ? "Not Given"
                                                        : subItem.value
                                                    }
                                                    placement="bottom-start"
                                                    PopperProps={{
                                                      modifiers: [
                                                        {
                                                          name: "offset",
                                                          options: {
                                                            offset: [-5, -10],
                                                          },
                                                        },
                                                      ],
                                                    }}
                                                  >
                                                    <p className="text-Primary_white text-sm text-left font-sans font-normal truncate">
                                                      {subItem?.data_type ===
                                                        "toggle" &&
                                                      typeof subItem?.value ===
                                                        "boolean" &&
                                                      subItem?.value == true
                                                        ? "Yes"
                                                        : subItem?.data_type ===
                                                            "multi_select_list" &&
                                                          subItem?.value
                                                            .length !== 0
                                                        ? subItem?.value?.join(
                                                            ","
                                                          )
                                                        : subItem?.data_type ===
                                                          "date_range"
                                                        ? (subItem?.value?.start_date).concat(
                                                            " - ",
                                                            subItem?.value
                                                              ?.end_date
                                                          )
                                                        : subItem?.data_type ===
                                                          "from_year_to_year"
                                                        ? (subItem?.value?.from)
                                                            .toString()
                                                            .concat(
                                                              " - ",
                                                              (subItem?.value?.to).toString()
                                                            )
                                                        : typeof subItem?.value !==
                                                          "object"
                                                        ? subItem.value
                                                        : "Not Given"}
                                                    </p>
                                                  </Tooltip>
                                                ) : (
                                                  <p className="text-Primary_white text-sm text-left font-sans font-normal capitalize">
                                                    {subItem?.data_type ===
                                                      "toggle" &&
                                                    subItem.hasOwnProperty(
                                                      "value"
                                                    ) === false
                                                      ? "No"
                                                      : "Not given"}
                                                  </p>
                                                )}
                                                <p
                                                  className={`text-Primary_grey  text-xs text-left font-sans font-normal mt-1 ${
                                                    !isLastInRow ? "mb-2.5" : ""
                                                  }`}
                                                >
                                                  {subItem?.data_type ===
                                                  "from_year_to_year"
                                                    ? "From year".concat(
                                                        " - ",
                                                        "To year"
                                                      )
                                                    : subItem?.data_type ===
                                                      "date_range"
                                                    ? "From date".concat(
                                                        " - ",
                                                        "To date"
                                                      )
                                                    : subItem.name}
                                                </p>
                                              </div>
                                              {!isLastInRow &&
                                                nextItemExists && (
                                                  <div className="border-r border-solid border-Blue_2"></div>
                                                )}
                                            </>
                                          );
                                        })}
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          )}
                        </div>
                        {attachments.length > 0 && (
                          <div className="p-5 h-auto w-full rounded-[20px] bg-Blue_5">
                            <p className="text-sm text-Primary_grey font-sans font-semibold mb-2.5">
                              Attachments
                            </p>
                            {attachments.map((obj) => {
                              if (obj?.name === "Hyperlink") {
                                return (
                                  <>
                                    <div className="flex flex-col gap-y-0.5">
                                      <p className="text-xs text-Primary_grey font-sans font-normal pb-0.5">
                                        URL
                                      </p>
                                      <div className="flex flex-col gap-y-0.5 w-full h-28 p-2.5 rounded-[10px] bg-Blue_3">
                                        <div className="flex flex-row items-center w-full h-[54px] p-2.5 rounded-[5px] bg-Blue_5">
                                          <img
                                            src={default_file}
                                            className="w-9 h-8 items-center"
                                          />
                                          <p className="ml-2.5 text-[10px] text-Primary_grey font-sans font-normal">
                                            N/A
                                          </p>
                                        </div>
                                        <p className="text-[10px] text-Pending font-sans font-normal truncate">
                                          {obj?.value ? (
                                            <a href={obj?.value} target="blank">
                                              {obj?.value}
                                            </a>
                                          ) : (
                                            "Not Given"
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <div className="flex flex-col gap-y-0.5 pt-5">
                                      <p className="text-xs text-Primary_grey font-sans font-normal pb-0.5">
                                        {obj?.value?.metadata?.mime_type ===
                                        "image/png"
                                          ? "Images"
                                          : "Files"}
                                      </p>
                                      <div className="flex flex-col items-center gap-x-2.5 w-full h-14 p-2.5 rounded-[10px] bg-Blue_3">
                                        <img
                                          src={
                                            // obj?.value?.metadata?.mime_type ===
                                            // "image/png"
                                            default_file
                                            // : require("../../../assets/FileFormatIcons/" +
                                            //     obj?.value?.metadata?.filename
                                            //       .slice(
                                            //         obj?.value?.metadata?.filename.indexOf(
                                            //           "."
                                            //         ) + 1
                                            //       )
                                            //       .toUpperCase() +
                                            //     ".svg")
                                          }
                                          className="w-9 h-8"
                                        />
                                        <div className="flex flex-col gap-y-0.5">
                                          <p className="text-xs text-Primary_white font-sans font-normal capitalize">
                                            {obj?.value?.metadata?.filename}
                                          </p>
                                          <p className="text-[10px] text-Primary_grey font-sans font-normal capitalize">
                                            {obj?.value?.metadata?.size +
                                              " ." +
                                              obj?.value?.metadata?.filename.slice(
                                                obj?.value?.metadata?.filename.indexOf(
                                                  "."
                                                ) + 1
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InternalTransactionDetails;
